import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'node_modules/body-scroll-lock';
import Flickity from 'web/libraries/flickity';
import Blazy from 'web/libraries/blazy';
import PhotoSwipe from 'node_modules/photoswipe';
import PhotoSwipeUI_Default from 'node_modules/photoswipe/dist/photoswipe-ui-default.js';
import 'node_modules/add-to-calendar-buttons/ouical.min.js';
import 'node_modules/core-js/client/shim.js';
import 'node_modules/whatwg-fetch';
import 'node_modules/focus-visible';
import 'node_modules/objectFitPolyfill';
import 'node_modules/focus-within-polyfill';
import 'node_modules/element-closest-polyfill';
import 'node_modules/nodelist-foreach-polyfill';

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

//
//  This code adds some genrealy used body state classes:
//  - window width (big or small according to breakpoints)
//
//* ----------------------------------------------------------------------------

var BodyStates = function () {
    function BodyStates() {
        _classCallCheck(this, BodyStates);

        this.body = this.getBody();
        this.largeBreakpoint = 1024;
        this.windowWidth = window.innerWidth;

        this.setBodyWidthClass();
        this.setBodyStyle();
        this.events();
    }

    _createClass(BodyStates, [{
        key: 'events',
        value: function events() {
            var _this = this;

            window.addEventListener('resize', this.adjustClasses.bind(this));
            document.querySelectorAll('.toolbar-tab').forEach(function (el) {
                el.addEventListener('click', _this.setBodyStyle.bind(_this));
            });
            window.addEventListener('DOMContentLoaded', this.setBodyStyle.bind(this));
            window.addEventListener('resize', this.setBodyStyle.bind(this));
        }
    }, {
        key: 'adjustClasses',
        value: function adjustClasses() {
            this.windowWidth = window.innerWidth;

            this.setBodyWidthClass();
        }
    }, {
        key: 'setBodyWidthClass',
        value: function setBodyWidthClass() {
            if (this.windowWidth > this.largeBreakpoint - 1 && !this.body.classList.contains('is-big')) {
                this.body.classList.add('is-big');
                this.body.classList.remove('is-small');
            } else if (this.windowWidth <= this.largeBreakpoint && !this.body.classList.contains('is-small')) {
                this.body.classList.add('is-small');
                this.body.classList.remove('is-big');
            }
        }
    }, {
        key: 'getBody',
        value: function getBody() {
            return document.querySelector('body');
        }
    }, {
        key: 'setBodyStyle',
        value: function setBodyStyle() {
            var _this2 = this;

            // Check that we are using IE.
            var ua = window.navigator.userAgent;
            var isIE = /MSIE|Trident|Edge/.test(ua
            // If Internet Explorer or Edge, set the paddings.
            );if (isIE) setTimeout(function () {
                var body = _this2.getBody();
                var style = body.getAttribute('style');
                if (style) {
                    // Get just the padding number.
                    var padding = parseFloat(style.replace(/[^\d.]*/g, ''));
                    var roundPadding = Math.ceil(padding);
                    body.setAttribute('style', 'padding-top: ' + roundPadding + 'px');
                }
            }, 500);
        }
    }]);

    return BodyStates;
}();

//* ----------------------------------------------------------------------------
//
//  This code is a fix for linkicons module -
//  replaces first fa prefix with fab so that FontAwesome icons
//  can be displayed
//
//* ----------------------------------------------------------------------------

var Linkicons = function () {
    function Linkicons() {
        _classCallCheck(this, Linkicons);

        this.linkicons = this.getLinkicons();
        this.replace();
    }

    _createClass(Linkicons, [{
        key: 'replace',
        value: function replace() {
            this.linkicons.forEach(function (el) {
                if (el.classList.contains('fa')) {
                    el.classList.remove('fa');
                    el.classList.add('fab');
                }
            });
        }
    }, {
        key: 'getLinkicons',
        value: function getLinkicons() {
            return Array.from(document.getElementsByClassName('linkicon__icon'));
        }
    }]);

    return Linkicons;
}();

//* ----------------------------------------------------------------------------
//
//  This code helps create dropdown menu accessible with tab key
//  + updates aria-expanded attribute of submenu parents
//  + adds option to dismiss submenues with ESC key
//  + adds option to dismiss submenues if clicking or tabbing out of the menu
//
//* ----------------------------------------------------------------------------

var Dropdown = function () {
    function Dropdown() {
        _classCallCheck(this, Dropdown);

        this.links = this.getLinks();
        this.li = this.getLi();
        this.target = 0;
        this.body = this.getBody();

        this.events();
        this.setAriaExpanded();
    }

    _createClass(Dropdown, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.links.forEach(function (el) {
                el.addEventListener('focus', _this.addFocus.bind(_this));
            });

            this.links.forEach(function (el) {
                el.addEventListener('focus', _this.addAria.bind(_this));
            });

            this.links.forEach(function (el) {
                el.addEventListener('mouseover', _this.addAriaHover.bind(_this));
            });

            this.links.forEach(function (el) {
                el.addEventListener('mouseout', _this.removeAriaHover.bind(_this));
            });

            this.body.addEventListener('keydown', this.removeFocus.bind(this));
            this.body.addEventListener('click', this.closeMenus.bind(this));
        }
    }, {
        key: 'setAriaExpanded',
        value: function setAriaExpanded() {
            this.links.forEach(function (el) {
                if (el.parentElement.classList.contains('has-submenu')) el.setAttribute('aria-expanded', 'false');
            });
        }
    }, {
        key: 'closeMenus',
        value: function closeMenus(e) {
            // if user click anywhere out of the main navigation and submenu
            // is opened it will be closed
            this.opened = this.li.filter(function (el) {
                return el.classList.contains('focused');
            })[0];

            if (!e.target.closest('.menu-main') && this.opened) {
                this.opened.classList.remove('focused');
                this.opened.querySelector('a').setAttribute('aria-expanded', 'false');
            }
        }
    }, {
        key: 'addFocus',
        value: function addFocus(e) {
            this.target = e.target;

            //  remove all prevoiusly set .focused classes
            this.links.forEach(function (el) {
                if (el.parentElement.classList.contains('focused')) el.parentElement.classList.remove('focused');
            }

            //  if current element has submenu add class .focused to its parent
            );if (this.target.parentElement.querySelector('.submenu') !== null) this.target.parentElement.classList.add('focused');
        }
    }, {
        key: 'removeFocus',
        value: function removeFocus(e) {
            this.target = e.target;
            this.opened = this.li.filter(function (el) {
                return el.classList.contains('focused');
            })[0];

            if ((e.keyCode === 27 || !e.target.closest('ul.menu-main')) && this.opened) {
                // focus currently opened menu item
                if (e.keyCode === 27) this.opened.querySelector('a').focus();

                this.links.forEach(function (el) {
                    el.parentElement.classList.remove('focused');

                    if (el.parentElement.classList.contains('has-submenu')) el.setAttribute('aria-expanded', 'false');
                });
            }
        }
    }, {
        key: 'addAriaHover',
        value: function addAriaHover(e) {
            var li = '';

            if (e.target.tagName === 'A') li = e.target.parentElement;else if (e.target.tagName === 'SPAN') li = e.target.parentElement.parentElement;else return;

            if (li.classList.contains('has-submenu')) li.querySelector('a').setAttribute('aria-expanded', 'true');

            if (li.closest('.has-submenu') && li.classList.contains('has-submenu')) li.closest('.has-submenu').querySelector('a').setAttribute('aria-expanded', 'true');
        }
    }, {
        key: 'removeAriaHover',
        value: function removeAriaHover(e) {
            var li = '';

            if (e.target.tagName === 'A') li = e.target.parentElement;else if (e.target.tagName === 'SPAN') li = e.target.parentElement.parentElement;else return;

            if (li.classList.contains('has-submenu') && !li.classList.contains('focused')) li.querySelector('a').setAttribute('aria-expanded', 'false');

            if (li.classList.contains('has-submenu') && li.closest('.has-submenu')) li.closest('.has-submenu').querySelector('a').setAttribute('aria-expanded', 'false');
        }
    }, {
        key: 'addAria',
        value: function addAria(e) {
            if (this.getIsDesktopView()) {
                this.target = e.target;

                this.links.forEach(function (el) {
                    if (el.parentElement.classList.contains('has-submenu')) if (el.parentElement.classList.contains('focused')) {
                        var submenuId = el.parentElement.querySelector('.submenu').getAttribute('id');
                        el.setAttribute('aria-expanded', 'true');
                        el.setAttribute('aria-controls', submenuId);
                    } else el.setAttribute('aria-expanded', 'false');
                });
            }
        }
    }, {
        key: 'getLinks',
        value: function getLinks() {
            return Array.from(document.querySelectorAll('.menu-main > li > a'));
        }
    }, {
        key: 'getLi',
        value: function getLi() {
            return Array.from(document.querySelectorAll('.menu-main > li'));
        }
    }, {
        key: 'getBody',
        value: function getBody() {
            return document.querySelector('body');
        }
    }, {
        key: 'getIsDesktopView',
        value: function getIsDesktopView() {
            if (this.body.classList.contains('is-big')) return true;else return false;
        }
    }]);

    return Dropdown;
}();

//
//  This code adds class .sticky to the header once it reaches
//  the top of the screen. It also adds class .menu-is-sticky to the body
//  which adds top padding to the page content when header is sticky to
//  avoid content jumping
//
//* ----------------------------------------------------------------------------

var StickyHeader = function () {
    function StickyHeader() {
        _classCallCheck(this, StickyHeader);

        this.render();
        this.toggleSticky();
        this.events();
    }

    _createClass(StickyHeader, [{
        key: 'events',
        value: function events() {
            var _this = this;

            window.addEventListener('load', function () {
                _this.render();
                _this.toggleSticky();
            });

            window.addEventListener('scroll', this.toggleSticky.bind(this));
            window.addEventListener('resize', this.toggleSticky.bind(this));

            if (!('MutationObserver' in window)) return;

            // Watch for admin toolbar height changes
            new window.MutationObserver(function () {
                return _this.toggleSticky();
            }).observe(document.body, { attributes: true });
        }
    }, {
        key: 'toggleSticky',
        value: function toggleSticky() {
            if (!this.getHeader()) return;

            this.setMenusLayout();

            if (window.innerWidth < 1024) return;

            var className = 'sticky';
            var bodyClassName = 'menu-is-sticky';
            var isSticky = this.getHeader().classList.contains(className);
            var toggleMethod = window.pageYOffset >= this.getHeader().offsetTop + this.getHeader().clientHeight - this.getBodyPadding() ? 'add' : 'remove';

            // No unneccessary repaints
            return toggleMethod === 'add' && !isSticky || toggleMethod === 'remove' && isSticky ? this.setClasses(toggleMethod, className, bodyClassName) : null;
        }
    }, {
        key: 'setClasses',
        value: function setClasses(toggleMethod, className, bodyClassName) {
            this.getHeader().classList[toggleMethod](className);
            document.body.classList[toggleMethod](bodyClassName);
        }
    }, {
        key: 'getHeader',
        value: function getHeader() {
            return document.querySelector('header');
        }
    }, {
        key: 'getMenubar',
        value: function getMenubar() {
            if (!this.getHeader()) return null;

            return this.getHeader().querySelector('#block-menubar');
        }
    }, {
        key: 'getMenubarSticky',
        value: function getMenubarSticky() {
            if (!this.getHeader()) return null;

            return this.getHeader().querySelector('.block-menu-bar-sticky');
        }
    }, {
        key: 'getMobilemenu',
        value: function getMobilemenu() {
            if (!this.getHeader()) return null;

            return this.getHeader().querySelector('#block-mobilemenu');
        }
    }, {
        key: 'getStickyBreadcrumbs',
        value: function getStickyBreadcrumbs() {
            return document.querySelector('.sticky-breadcrumbs');
        }
    }, {
        key: 'getSkipLink',
        value: function getSkipLink() {
            return document.querySelector('a.skip-link');
        }
    }, {
        key: 'getBodyPadding',
        value: function getBodyPadding() {
            return Number(document.body.style.paddingTop.replace(/\D/g, '') || '0');
        }
    }, {
        key: 'setMenusLayout',
        value: function setMenusLayout() {
            var _this2 = this;

            if (!this.getMenubar()) return;

            var headerWidth = (this.getHeader() || {}).clientWidth || window.innerWidth;

            var els = [this.getMenubar(), this.getMenubarSticky(), this.getMobilemenu(), this.getStickyBreadcrumbs(), this.getSkipLink()];

            els.forEach(function (el) {
                if (!el) return;

                if (el.style.maxWidth !== headerWidth + 'px') el.style.maxWidth = headerWidth + 'px';

                var top = _this2.getBodyPadding() + (el === _this2.getStickyBreadcrumbs() ? (_this2.getMenubarSticky() || {}).clientHeight || 0 : 0) + 'px';

                if (el.style.top !== top) el.style.top = top;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.getMenubar() || this.getMenubarSticky()) return;

            var menubar = this.getMenubar();
            var menubarClone = menubar.cloneNode(true);

            menubarClone.classList.add('block-menu-bar-sticky');

            if (menubar.id) menubarClone.id = menubar.id + '-clone';

            Array.from(menubarClone.querySelectorAll('[id]')).forEach(function (el) {
                var id = el.id;
                el.id = id + '-modal-clone';

                var selectorExp = new RegExp('(["\']#*)' + id + '("|\')', 'g');

                menubarClone.innerHTML = menubarClone.innerHTML.replace(selectorExp, '$1' + el.id + '$2');
            });

            menubar.parentElement.appendChild(menubarClone);
        }
    }]);

    return StickyHeader;
}();

//
//  This code adds class .sticky to the hero basic content section once it reaches
//  the collapsed main nav.
//
//* ----------------------------------------------------------------------------

var StickyBreadcrumbs = function () {
    function StickyBreadcrumbs() {
        _classCallCheck(this, StickyBreadcrumbs);

        this.toggleSticky();
        this.events();
    }

    _createClass(StickyBreadcrumbs, [{
        key: 'events',
        value: function events() {
            var _this = this;

            window.addEventListener('load', function () {
                return _this.toggleSticky();
            });
            window.addEventListener('scroll', this.toggleSticky.bind(this));
            window.addEventListener('resize', this.toggleSticky.bind(this));

            if (!('MutationObserver' in window)) return;

            // Watch for admin toolbar height changes
            new window.MutationObserver(function (mutations) {
                return mutations.filter(function (obj) {
                    return obj.attributeName === 'style';
                }).length ? _this.toggleSticky() : null;
            }).observe(document.body, { attributes: true });
        }
    }, {
        key: 'toggleSticky',
        value: function toggleSticky() {
            if (!this.getBreadcrumbs()) return;

            if (window.innerWidth < 1024) return;

            var className = 'sticky';
            var hiddenClass = 'is-hidden';
            var isSticky = this.getBreadcrumbs().classList.contains(className);
            var block = this.getBreadcrumbs().parentElement;
            var toggleMethod = window.pageYOffset >= block.offsetTop + block.clientHeight - this.getBodyPadding() ? 'add' : 'remove';

            // No unneccessary repaints
            return toggleMethod === 'add' && !isSticky || toggleMethod === 'remove' && isSticky ? this.setClasses(toggleMethod, className, hiddenClass) : null;
        }
    }, {
        key: 'setClasses',
        value: function setClasses(toggleMethod, className, hiddenClass) {
            this.getBreadcrumbs().classList[toggleMethod](className);
        }
    }, {
        key: 'getBreadcrumbs',
        value: function getBreadcrumbs() {
            return document.querySelector('.sticky-breadcrumbs');
        }
    }, {
        key: 'getHeroContent',
        value: function getHeroContent() {
            return document.querySelector('.hero-content');
        }
    }, {
        key: 'getBodyPadding',
        value: function getBodyPadding() {
            return Number(document.body.style.paddingTop.replace(/\D/g, '') || '0');
        }
    }]);

    return StickyBreadcrumbs;
}();

var VideoLightbox = function () {
    function VideoLightbox() {
        _classCallCheck(this, VideoLightbox);

        this.body = this.getBody();
        this.openButton = this.getOpenButton();
        this.closeButton = this.getcloseButton();
        this.lightbox = this.getLightbox();
        this.embed = this.getEmbed();
        this.opened = 0;

        this.events();
    }

    _createClass(VideoLightbox, [{
        key: 'events',
        value: function events() {
            if (this.openButton) this.openButton.addEventListener('click', this.openLightbox.bind(this));

            if (this.closeButton) this.closeButton.addEventListener('click', this.closeLightbox.bind(this));

            if (this.lightbox) this.lightbox.addEventListener('click', this.closeLightbox.bind(this));

            window.addEventListener('keydown', this.escLightbox.bind(this));
        }
    }, {
        key: 'escLightbox',
        value: function escLightbox(e) {
            var key = e.keyCode;

            if (key === 27 && this.opened === 1) this.closeLightbox();
        }
    }, {
        key: 'openLightbox',
        value: function openLightbox() {
            this.lightbox.classList.add('is-opened');
            disableBodyScroll(this.body);

            this.opened = 1;
        }
    }, {
        key: 'closeLightbox',
        value: function closeLightbox() {
            this.lightbox.classList.remove('is-opened');
            enableBodyScroll(this.body);
            this.opened = 0;

            clearAllBodyScrollLocks();
        }
    }, {
        key: 'getBody',
        value: function getBody() {
            return document.querySelector('body');
        }
    }, {
        key: 'getOpenButton',
        value: function getOpenButton() {
            return document.querySelector('.js-open-video');
        }
    }, {
        key: 'getcloseButton',
        value: function getcloseButton() {
            return document.querySelector('.js-close-video');
        }
    }, {
        key: 'getLightbox',
        value: function getLightbox() {
            return document.querySelector('.video-lightbox');
        }
    }, {
        key: 'getEmbed',
        value: function getEmbed() {
            return document.querySelector('.video-lightbox .media-oembed-content iframe');
        }
    }]);

    return VideoLightbox;
}();

var MobileMenu = function () {
    function MobileMenu() {
        _classCallCheck(this, MobileMenu);

        this.body = this.getBody();
        this.burger = this.getBurgerIcon();
        this.header = this.getHeader();
        this.mobileMenu = this.getMobileMenu();
        this.icon = this.getIcon();
        this.submenuArrows = this.getSubmenuArrows();
        this.backToParentButton = this.getBackToParentButton();
        this.mobileSubmenus = this.getMobileSubmenu();
        this.openedSubmenus = [];
        this.menuOpened = 0;
        this.submenuOpened = 0;

        if (this.mobileMenu) this.mobileMenu.setAttribute('tabindex', -1);

        this.events();
    }

    _createClass(MobileMenu, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.burger.addEventListener('click', this.toggleMenu.bind(this));
            this.body.addEventListener('keydown', this.closeMenu.bind(this));

            if (this.submenuArrows) this.submenuArrows.forEach(function (el) {
                el.addEventListener('click', _this.openSubmenu.bind(_this));
            });

            if (this.backToParentButton) this.backToParentButton.forEach(function (el) {
                el.addEventListener('click', _this.closeSubmenu.bind(_this));
            });

            window.addEventListener('resize', this.adjustNavigation.bind(this));
        }
    }, {
        key: 'toggleMenu',
        value: function toggleMenu(e) {
            return !this.menuOpened ? this.openMenu() : this.closeMenu(e);
        }
    }, {
        key: 'openMenu',
        value: function openMenu() {
            this.header.classList.add('mobile-opened');
            disableBodyScroll(this.mobileMenu);
            this.icon.innerText = 'close';
            this.menuOpened = 1;
            this.setSiblingVisibility();
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu(e) {
            var _this2 = this;

            var canUpdate = this.canUpdate(e);
            if (canUpdate & this.menuOpened === 1) {
                this.header.classList.remove('mobile-opened');
                this.mobileMenu.classList.add('is-closing');
                setTimeout(function () {
                    return _this2.mobileMenu.classList.remove('is-closing');
                }, 700);
                enableBodyScroll(this.mobileMenu);
                clearAllBodyScrollLocks();
                this.icon.innerText = 'menu';
                this.menuOpened = 0;

                if (this.submenuOpened) this.closeAllSubmenus();

                this.mobileMenu.removeAttribute('role', 'dialog');
                this.setSiblingVisibility();
                this.burger.focus();
            }
        }
    }, {
        key: 'canUpdate',
        value: function canUpdate(e) {
            return !e || e.type === 'click' || e.type === 'keydown' && e.which === 27;
        }
    }, {
        key: 'openSubmenu',
        value: function openSubmenu(e) {
            var element = e.target;
            var submenu = element.closest('.has-submenu').querySelector('.submenu');

            submenu.classList.add('is-opened');
            submenu.classList.add('is-active');

            this.disableMenuScroll();

            if (this.submenuOpened) this.openedSubmenus[this.submenuOpened - 1].classList.remove('is-active');

            this.openedSubmenus.push(submenu);
            this.submenuOpened++;

            if (this.submenuOpened && !this.mobileMenu.classList.contains('is-hidden')) this.mobileMenu.classList.add('is-hidden');
        }
    }, {
        key: 'closeSubmenu',
        value: function closeSubmenu(e) {
            e.preventDefault();

            var element = e.target;
            var submenu = element.closest('.submenu');

            submenu.classList.remove('is-opened');
            submenu.classList.remove('is-active');
            submenu.classList.add('is-closing');
            setTimeout(function () {
                return submenu.classList.remove('is-closing');
            }, 700);

            this.submenuOpened--;

            if (this.submenuOpened) this.openedSubmenus[this.submenuOpened - 1].classList.add('is-active');

            this.openedSubmenus.pop();
            this.disableMenuScroll();

            if (!this.submenuOpened && this.mobileMenu.classList.contains('is-hidden')) this.mobileMenu.classList.remove('is-hidden');
        }
    }, {
        key: 'closeAllSubmenus',
        value: function closeAllSubmenus() {
            this.openedSubmenus.forEach(function (el) {
                el.classList.remove('is-opened');

                if (el.classList.contains('is-active')) el.classList.remove('is-active');
            });

            this.header.classList.remove('submenu-opened');
            this.submenuOpened = 0;
            this.openedSubmenus = [];

            if (this.mobileMenu.classList.contains('is-hidden')) this.mobileMenu.classList.remove('is-hidden');
        }
    }, {
        key: 'disableMenuScroll',
        value: function disableMenuScroll() {
            if (!this.submenuOpened) this.header.classList.toggle('submenu-opened');
        }
    }, {
        key: 'adjustNavigation',
        value: function adjustNavigation() {
            if (this.body.classList.contains('is-big') && this.header.classList.contains('mobile-opened')) this.closeMenu();
        }
    }, {
        key: 'setSiblingVisibility',
        value: function setSiblingVisibility() {
            var isOpened = this.getHeader() && this.getHeader().classList.contains('mobile-opened');

            Array.from(document.querySelectorAll(['.skip-index', 'main', 'footer', '.region-alert', '.region-search', '#sliding-popup'].join(', '))).forEach(function (el) {
                if (isOpened && !el.classList.contains('hidden') || !isOpened && el.classList.contains('hidden')) el.classList.toggle('hidden');
            });
        }
    }, {
        key: 'getBody',
        value: function getBody() {
            return document.querySelector('body');
        }
    }, {
        key: 'getBurgerIcon',
        value: function getBurgerIcon() {
            return document.querySelector('.js-open-mobile');
        }
    }, {
        key: 'getHeader',
        value: function getHeader() {
            return document.querySelector('.region-header');
        }
    }, {
        key: 'getMobileMenu',
        value: function getMobileMenu() {
            return this.header.querySelector('.block-mobile-menu');
        }
    }, {
        key: 'getIcon',
        value: function getIcon() {
            return this.burger.querySelector('i');
        }
    }, {
        key: 'getSubmenuArrows',
        value: function getSubmenuArrows() {
            return Array.from(document.querySelectorAll('.js-open-submenu'));
        }
    }, {
        key: 'getBackToParentButton',
        value: function getBackToParentButton() {
            return Array.from(document.querySelectorAll('.js-back-to-parent'));
        }
    }, {
        key: 'getMobileSubmenu',
        value: function getMobileSubmenu() {
            return Array.from(this.mobileMenu.querySelectorAll('.submenu'));
        }
    }]);

    return MobileMenu;
}();

//* ----------------------------------------------------------------------------
//
//  This code takes care of who we are PT functionality
//  - opens first tab on load and sets first image
//  - opens and closes tabs
//  - changes image in the box
//
//* ----------------------------------------------------------------------------

var WhoWeAre = function () {
    function WhoWeAre(el) {
        _classCallCheck(this, WhoWeAre);

        this.el = el;
        this.items = this.getItems();
        this.images = this.getImages();
        this.imgHolder = this.getImageHolder();
        this.box = this.getImageBox();
        this.openedItemIndex = 0;

        this.openFirstTab();
        this.events();
    }

    _createClass(WhoWeAre, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.items.forEach(function (el) {
                el.addEventListener('click', _this.toggleItem.bind(_this));
            });
        }
    }, {
        key: 'openFirstTab',
        value: function openFirstTab() {
            this.changeTabs(this.openedItemIndex);
            this.setImage(this.openedItemIndex);

            this.animateSlide();
        }
    }, {
        key: 'toggleItem',
        value: function toggleItem(e) {
            var target = e.target.closest('.field-who-we-are-items:not(.is-opened)');

            if (target) {
                var index = this.getIndex(target);
                this.changeTabs(index);
                this.setImage(index);
                this.openedItemIndex = index;

                this.animateSlide();
            }
        }
    }, {
        key: 'getIndex',
        value: function getIndex(target) {
            return this.items.indexOf(target);
        }
    }, {
        key: 'changeTabs',
        value: function changeTabs(index) {
            this.items[this.openedItemIndex].classList.remove('is-opened');
            this.items[index].classList.add('is-opened');
        }
    }, {
        key: 'setImage',
        value: function setImage(index) {
            var bgUrl = this.images[index];
            this.box.setAttribute('style', bgUrl);

            if (this.openedItemIndex !== index) this.setParentBackground(index);
        }
    }, {
        key: 'setParentBackground',
        value: function setParentBackground(index) {
            var prevImgUrl = this.images[this.openedItemIndex];
            this.imgHolder.setAttribute('style', prevImgUrl);
        }
    }, {
        key: 'animateSlide',
        value: function animateSlide() {
            var _this2 = this;

            this.box.classList.add('animate-slide-open');
            setTimeout(function () {
                return _this2.box.classList.remove('animate-slide-open');
            }, 600);
        }
    }, {
        key: 'getItems',
        value: function getItems() {
            return Array.from(this.el.querySelectorAll('.field-who-we-are-items'));
        }
    }, {
        key: 'getImages',
        value: function getImages() {
            var images = Array.from(this.el.querySelectorAll('.img-background'));
            return images.map(function (img) {
                return img.getAttribute('style');
            });
        }
    }, {
        key: 'getImageHolder',
        value: function getImageHolder() {
            return this.el.querySelector('.img-wrap');
        }
    }, {
        key: 'getImageBox',
        value: function getImageBox() {
            return this.el.querySelector('.box');
        }
    }]);

    return WhoWeAre;
}();

//* ----------------------------------------------------------------------------
//
//  This code takes care of:
//  - opening tabs
//  - closing tabs
//  of FAQ PT
//
//* ----------------------------------------------------------------------------

var Faqs = function () {
    function Faqs(el) {
        _classCallCheck(this, Faqs);

        this.el = el;
        this.faqs = this.getFaqs();
        this.questions = this.getQuestions();
        this.setarias = this.setAria();
        this.numberSpans = this.getNumberSpans();
        this.events();
    }

    _createClass(Faqs, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.questions.forEach(function (el) {
                el.addEventListener('click', _this.toggleAnswer.bind(_this));
            });

            this.questions.forEach(function (el) {
                el.addEventListener('onload', _this.setAria.bind(_this));
            });

            this.numberSpans.forEach(function (el) {
                el.addEventListener('click', _this.toggleAnswer.bind(_this));
            });
        }
    }, {
        key: 'toggleAnswer',
        value: function toggleAnswer(e) {
            var _this2 = this;

            var target = e.target.closest('.field-faq').querySelector('.faq-quetion');
            var index = this.getIndex(target);

            this.faqs[index].classList.toggle('is-opened');
            if (this.faqs[index].classList.contains('is-opened')) {
                this.faqs[index].classList.add('is-closing');
                setTimeout(function () {
                    _this2.faqs[index].classList.remove('is-closing');
                }, 600);
                this.faqs[index].querySelector('.faq-quetion').setAttribute('aria-expanded', 'true');
                this.faqs[index].querySelector('.faq-answer').style.display = 'block';
            } else {
                this.faqs[index].querySelector('.faq-quetion').setAttribute('aria-expanded', 'false');
                this.faqs[index].querySelector('.faq-answer').style.display = 'none';
            }
        }
    }, {
        key: 'setAria',
        value: function setAria() {
            document.querySelectorAll('.faq-quetion').forEach(function (el) {
                var aid = el.parentElement.parentElement.querySelector('.faq-answer').id;
                el.setAttribute('aria-controls', aid);
            });
            document.querySelectorAll('.faq-answer').forEach(function (el) {
                var qid = el.parentElement.querySelector('span:not(.icon-span)').id;
                el.setAttribute('aria-labelledby', qid);
            });
        }
    }, {
        key: 'getIndex',
        value: function getIndex(target) {
            return this.questions.indexOf(target);
        }
    }, {
        key: 'getFaqs',
        value: function getFaqs() {
            return Array.from(this.el.getElementsByClassName('field-faq'));
        }
    }, {
        key: 'getQuestions',
        value: function getQuestions() {
            return Array.from(this.el.getElementsByClassName('faq-quetion'));
        }
    }, {
        key: 'getNumberSpans',
        value: function getNumberSpans() {
            return Array.from(this.el.getElementsByClassName('number'));
        }
    }]);

    return Faqs;
}();

var FeaturedContent = function () {
    function FeaturedContent(el, adaptiveHeight) {
        _classCallCheck(this, FeaturedContent);

        this.el = el;
        this.adaptiveHeight = adaptiveHeight;

        this.carousel = new Flickity(this.el, {
            cellAlign: 'left',
            prevNextButtons: false,
            pageDots: false,
            adaptiveHeight: this.adaptiveHeight,
            accessibility: false
        });

        this.render();
        this.revalidateLazyLoad();
        this.events();
    }

    _createClass(FeaturedContent, [{
        key: 'events',
        value: function events() {
            window.addEventListener('resize', this.resetAriaHidden.bind(this));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this = this;

            var nextBtns = Array.from(this.el.querySelectorAll('.arrow-next'));
            var prevBtns = Array.from(this.el.querySelectorAll('.arrow-prev'));
            var numbers = Array.from(this.el.querySelectorAll('.number'));
            var slides = Array.from(this.el.querySelectorAll('.image'));
            var slider = this.el.closest('.is-slider');

            nextBtns.forEach(function (el, i) {
                return i + 1 === nextBtns.length ? el.setAttribute('disabled', '') : el.addEventListener('click', _this.adjustSlide.bind(_this, 'next'));
            });

            prevBtns.forEach(function (el, i) {
                return !i ? el.setAttribute('disabled', '') : el.addEventListener('click', _this.adjustSlide.bind(_this, 'prev'));
            });

            numbers.forEach(function (el, i) {
                var idx = el.querySelector('.slider-nmb');
                var total = el.querySelector('.total-nmb');

                if (!idx || !total) {
                    el.style.display = 'none';
                    return;
                }

                idx.innerText = i + 1;
                total.innerText = numbers.length;
            });

            slides.forEach(function (el) {
                el.addEventListener('click', function () {
                    return _this.carousel.select(slides.indexOf(el));
                });
            });

            this.setRoleAttributes();
            slider.classList.remove('is-temporary');
            this.carousel.resize();
            this.resetAriaHidden();
        }
    }, {
        key: 'adjustSlide',
        value: function adjustSlide(direction) {
            var _this2 = this;

            direction === 'next' ? this.carousel.next() : this.carousel.previous();

            setTimeout(function () {
                _this2.getFirstFocusableElement().focus();
            }, 500);

            setTimeout(function () {
                _this2.resetAriaHidden();
            }, 900);
        }
    }, {
        key: 'setRoleAttributes',
        value: function setRoleAttributes() {
            this.getSlider().setAttribute('role', 'list');
            this.getSlides().forEach(function (el) {
                el.setAttribute('role', 'list-item');
            });
        }
    }, {
        key: 'resetAriaHidden',
        value: function resetAriaHidden() {
            this.getSlides().forEach(function (el) {
                var leftPosition = el.getBoundingClientRect().left;
                var rightPosition = el.getBoundingClientRect().right;
                var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

                if (rightPosition < 0 || leftPosition > width) el.setAttribute('aria-hidden', 'true');else el.removeAttribute('aria-hidden');
            });
        }
    }, {
        key: 'revalidateLazyLoad',
        value: function revalidateLazyLoad() {
            // Revalidate blazy in the carousel, so the images get displayed on
            // slide change event.
            var bLazy = new Blazy({
                // The offset controls how early you want the elements to be loaded
                // before they’re visible.
                offset: 600
            });
            this.carousel.on('change', function () {
                bLazy.revalidate();
            });
        }
    }, {
        key: 'getSlider',
        value: function getSlider() {
            return this.el.querySelector('.flickity-slider');
        }
    }, {
        key: 'getSlides',
        value: function getSlides() {
            return Array.from(this.el.querySelectorAll('.flickity-slider > .field'));
        }
    }, {
        key: 'getActiveSlide',
        value: function getActiveSlide() {
            return this.el.querySelector('.is-selected');
        }
    }, {
        key: 'getFirstFocusableElement',
        value: function getFirstFocusableElement() {
            return Array.from(this.getActiveSlide().querySelectorAll('button:not([disabled])'))[0];
        }
    }]);

    return FeaturedContent;
}();

/*  eslint-enable */

var Gallery = function () {
    function Gallery(el) {
        _classCallCheck(this, Gallery);

        this.el = el;
        this.gallery = this.getGallery();
        this.aElements = this.getLinks();
        this.pswp = this.getPswp();
        this.container = [];
        this.index = 0;
        this.options = 0;
        this.item = 0;
        this.gallery = 0;
        this.aria = this.setAria();
        this.closeButton = this.getCloseButton();
        this.nextButton = this.getNextButton();
        this.prevButton = this.getPrevButton();
        this.setUp();
        this.events();
    }

    _createClass(Gallery, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.aElements.forEach(function (el) {
                el.addEventListener('click', _this.open.bind(_this));
            });
        }
    }, {
        key: 'setUp',
        value: function setUp() {
            var _this2 = this;

            this.aElements.forEach(function (el) {
                // setup photoswipe items
                _this2.item = {
                    src: el.getAttribute('href'),
                    w: el.getAttribute('data-photoswipe-width') || el.parentElement.clientWidth,
                    h: el.getAttribute('data-photoswipe-height') || el.parentElement.clientHeight,
                    title: el.getAttribute('data-caption')
                };
                _this2.container.push(_this2.item);
            });
        }
    }, {
        key: 'open',
        value: function open(e) {
            e.preventDefault();
            var target = e.target.closest('a'
            // get index of clicked link
            );this.index = this.getIndex(target

            // setup photoswipe options
            );this.options = {
                index: this.index,
                bgOpacity: 1,
                showAnimationDuration: 300,
                hideAnimationDuration: 300,
                maxSpreadZoom: 2,
                closeOnScroll: false,
                closeOnVerticalDrag: false
            };
            this.initialize();
            this.setAria();
        }
    }, {
        key: 'getIndex',
        value: function getIndex(target) {
            return this.aElements.indexOf(target);
        }
    }, {
        key: 'initialize',
        value: function initialize() {
            this.gallery = new PhotoSwipe(this.pswp, PhotoSwipeUI_Default, this.container, this.options);
            this.gallery.init();

            this.closeButton.addEventListener('keyup', this.closeModal.bind(this));
            this.closeButton.addEventListener('click', this.closeModal.bind(this));
            this.pswp.addEventListener('click', this.removeAriaHidden.bind(this));
            this.nextButton.addEventListener('keyup', this.goNext.bind(this));
            this.nextButton.addEventListener('click', this.goNext.bind(this));
            this.prevButton.addEventListener('keyup', this.goPrev.bind(this));
            this.prevButton.addEventListener('click', this.goPrev.bind(this));
        }
    }, {
        key: 'setAria',
        value: function setAria() {
            var container = document.querySelector('.layout-container');
            if (this.pswp.classList.contains('pswp--open')) container.setAttribute('aria-hidden', 'true');
        }
    }, {
        key: 'closeModal',
        value: function closeModal(e) {
            var _this3 = this;

            if (!this.getIsIEBrowser()) {
                if (e.type === 'click' && e.detail === 1 || e.type === 'keyup' && e.keyCode === 13) {
                    this.gallery.close();
                    this.removeAriaHidden(e);
                    setTimeout(function () {
                        _this3.aElements[0].focus();
                    }, 300);
                }
            } else if (this.getIsIEBrowser()) if (e.type === 'click' && !(e.screenX !== 0 && e.screenY !== 0) || e.type === 'keyup' && e.keyCode === 13) {
                this.gallery.close();
                this.removeAriaHidden(e);
                setTimeout(function () {
                    _this3.aElements[0].focus();
                }, 300);
            }
        }
    }, {
        key: 'goNext',
        value: function goNext(e) {
            if (!this.getIsIEBrowser()) {
                if (e.type === 'click' && e.detail === 1 || e.type === 'keyup' && e.keyCode === 13) this.gallery.next();
            } else if (this.getIsIEBrowser()) if (e.type === 'click' && e.screenX !== 0 && e.screenY !== 0 || e.type === 'keyup' && e.keyCode === 13) this.gallery.next();
        }
    }, {
        key: 'goPrev',
        value: function goPrev(e) {
            e.preventDefault();

            if (!this.getIsIEBrowser()) {
                if (e.type === 'click' && e.detail === 1 || e.type === 'keyup' && e.keyCode === 13) this.gallery.prev();
            } else if (this.getIsIEBrowser()) if (e.type === 'click' && e.screenX !== 0 && e.screenY !== 0 || e.type === 'keyup' && e.keyCode === 13) this.gallery.prev();
        }
    }, {
        key: 'removeAriaHidden',
        value: function removeAriaHidden(e) {
            var container = document.querySelector('.layout-container');

            if (!this.getIsIEBrowser()) {
                if (e.detail === 1) container.removeAttribute('aria-hidden', 'false');
            } else if (this.getIsIEBrowser()) if (e.screenX === 0 && e.screenY === 0) container.removeAttribute('aria-hidden', 'false');
        }
    }, {
        key: 'getLinks',
        value: function getLinks() {
            return Array.from(this.el.getElementsByTagName('a'));
        }
    }, {
        key: 'getGallery',
        value: function getGallery() {
            return Array.from(this.el.getElementsByTagName('img'));
        }
    }, {
        key: 'getPswp',
        value: function getPswp() {
            return document.getElementsByClassName('pswp')[0];
        }
    }, {
        key: 'getCloseButton',
        value: function getCloseButton() {
            return document.querySelector('.close__button');
        }
    }, {
        key: 'getNextButton',
        value: function getNextButton() {
            return document.querySelector('.next__button');
        }
    }, {
        key: 'getPrevButton',
        value: function getPrevButton() {
            return document.querySelector('.prev__button');
        }
    }, {
        key: 'getIsIEBrowser',
        value: function getIsIEBrowser() {
            var userAgent = window.navigator.userAgent;
            var isIE = /MSIE|Trident|Edge\//.test(userAgent);

            if (isIE) return true;else return false;
        }
    }]);

    return Gallery;
}();

//* ----------------------------------------------------------------------------
//
//  This code takes care of share button functionality
//  - opens share button
//  - closes share button
//  - toggles between two buttons
//
//* ----------------------------------------------------------------------------

var SocialButtons = function () {
    function SocialButtons(el) {
        _classCallCheck(this, SocialButtons);

        this.el = el;
        this.shareButtons = this.getShareButtons();

        this.events();
    }

    _createClass(SocialButtons, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.shareButtons.forEach(function (el) {
                el.addEventListener('click', _this.toggleButton.bind(_this));
            });
        }
    }, {
        key: 'toggleButton',
        value: function toggleButton(e) {
            var _this2 = this;

            var target = e.target.closest('.button-wrap');
            var isOpened = target.classList.contains('is-opened');
            var iconText = target.classList.contains('share') ? 'share' : 'date_range';
            var otherIcon = target.classList.contains('share') ? 'date_range' : 'share';
            this.el.addEventListener('keydown', this.checkFocused.bind(this, target, iconText)

            // toggle current button
            );isOpened ? this.closeButton(target, iconText) : this.openButton(target, 'close'

            // close prev opened buttons
            );this.shareButtons.forEach(function (el) {
                if (el.classList.contains('is-opened') && el !== target) _this2.closeButton(el, otherIcon);
            });
        }

        // on tab key if button is opened - close button when focused element is not inside

    }, {
        key: 'checkFocused',
        value: function checkFocused(target, iconText, e) {
            var _this3 = this;

            setTimeout(function () {
                var currentEl = _this3.getCurrentFocusedEl(target);

                if (e.which === 9 && !target.contains(currentEl) && target.classList.contains('is-opened')) _this3.closeButton(target, iconText);
            }, 150);
        }
    }, {
        key: 'openButton',
        value: function openButton(el, text) {
            var labelText = el.classList.contains('share') ? text + ' share' : text + ' calendar';

            el.classList.add('is-opened');
            this.switchIcon(el, text);
            this.switchAriaLabel(el, labelText);
            this.animate(el, true);
            this.makeAccessible(el, true);
        }
    }, {
        key: 'closeButton',
        value: function closeButton(el, text) {
            var ariaText = text === 'date_range' ? 'Add to calendar' : 'Share';

            el.classList.remove('is-opened');
            this.switchIcon(el, text);
            this.switchAriaLabel(el, ariaText);
            this.animate(el, false);
            this.makeAccessible(el, false);
        }
    }, {
        key: 'switchIcon',
        value: function switchIcon(el, iconText) {
            el.querySelector('i').innerText = iconText;
        }
    }, {
        key: 'switchAriaLabel',
        value: function switchAriaLabel(el, iconText) {
            el.querySelector('i').closest('button').setAttribute('aria-label', iconText);
            el.querySelector('i').closest('button').querySelector('.text').innerText = iconText;
        }
    }, {
        key: 'animate',
        value: function animate(el, openening) {
            if (openening) {
                el.classList.add('is-opening');
                setTimeout(function () {
                    return el.classList.remove('is-opening');
                }, 350);
            } else {
                el.classList.add('is-closing');
                setTimeout(function () {
                    return el.classList.remove('is-closing');
                }, 350);
            }
        }
    }, {
        key: 'makeAccessible',
        value: function makeAccessible(element, _makeAccessible) {
            var links = this.getLinks(element);
            var tabIndex = _makeAccessible ? 0 : -1;

            links.forEach(function (el) {
                el.setAttribute('tabindex', tabIndex);
            });
        }
    }, {
        key: 'getShareButtons',
        value: function getShareButtons() {
            return Array.from(this.el.querySelectorAll('.share, .calendar'));
        }
    }, {
        key: 'getLinks',
        value: function getLinks(el) {
            return Array.from(el.querySelectorAll('a'));
        }
    }, {
        key: 'getCurrentFocusedEl',
        value: function getCurrentFocusedEl(el) {
            return el.querySelector(':focus');
        }
    }]);

    return SocialButtons;
}();

//* ----------------------------------------------------------------------------
//
//  This code creates a custom select div with custom options list (for styling)
//  that interacts with the original select element
//  Reference: https://www.w3schools.com/howto/howto_custom_select.asp
//
//* ----------------------------------------------------------------------------

var CustomSelect = function () {
    function CustomSelect(el) {
        _classCallCheck(this, CustomSelect);

        if (el.querySelectorAll('.select-selected').length) return false;

        this.el = el;
        this.body = this.getBody();
        this.selectElement = this.getSelectElement();
        this.form = this.getForm();
        this.listOpened = false;

        this.createNewSelect();
        this.events();
    }

    _createClass(CustomSelect, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.getCustomSelectBox().addEventListener('click', this.toggleOptionsList.bind(this));
            this.getCustomSelectBox().addEventListener('keydown', this.makeListAccessible.bind(this));
            this.getCustomSelectBox().addEventListener('keydown', this.openOptionsList.bind(this));
            this.getCustomItems().forEach(function (el) {
                el.addEventListener('keydown', _this.navigateList.bind(_this));
            });
            this.body.addEventListener('keydown', this.checkFocused.bind(this));
            window.addEventListener('click', this.closeOptionsList.bind(this));
            window.addEventListener('keydown', this.closeCombobox.bind(this));
        }
    }, {
        key: 'closeCombobox',
        value: function closeCombobox(e) {
            if (e.which === 27 && !this.getSelectListElement().classList.contains('select-hide')) {
                this.toggleOptionsList();
                this.getCustomSelectBox().focus();
            }
        }
    }, {
        key: 'navigateList',
        value: function navigateList(e) {
            var target = e.target;
            var index = this.getCustomItems().indexOf(target);

            if (e.which === 40 || e.which === 9) {
                e.preventDefault();
                target.removeAttribute('id');

                if (this.getCustomItems()[index + 1]) {
                    this.getCustomItems()[index + 1].setAttribute('id', 'selected_option');
                    this.getCustomItems()[index + 1].focus();
                } else {
                    this.getCustomItems()[0].setAttribute('id', 'selected_option');
                    this.getCustomItems()[0].focus();
                }
            } else if (e.which === 38 || e.shiftKey && e.which === 9) {
                e.preventDefault();
                target.removeAttribute('id');

                if (this.getCustomItems()[index - 1]) {
                    this.getCustomItems()[index - 1].setAttribute('id', 'selected_option');
                    this.getCustomItems()[index - 1].focus();
                } else {
                    this.getCustomItems()[this.getCustomItems().length - 1].setAttribute('id', 'selected_option');
                    this.getCustomItems()[this.getCustomItems().length - 1].focus();
                }
            }
        }
    }, {
        key: 'openOptionsList',
        value: function openOptionsList(e) {
            if (e.which === 40) {
                e.preventDefault();

                e.target.getAttribute('aria-expanded') === 'false' ? this.toggleOptionsList() : this.getCustomItems()[0].focus();
            }
        }

        // Custom select element events and accessibility adaptations

    }, {
        key: 'toggleOptionsList',
        value: function toggleOptionsList() {
            this.getSelectListElement().classList.toggle('select-hide');
            this.getCustomSelectBox().closest('.form-item > .inner').classList.toggle('is-opened');
            this.makeOptionsAccessible();
            if (this.listOpened) {
                this.getCustomSelectBox().setAttribute('aria-expanded', true);
                this.getCustomItems()[0].focus();
            } else this.getCustomSelectBox().setAttribute('aria-expanded', false);
        }
    }, {
        key: 'makeOptionsAccessible',
        value: function makeOptionsAccessible() {
            this.listOpened = !this.listOpened;

            this.listOpened ? this.getCustomItems().map(function (el) {
                return el.setAttribute('tabindex', 0);
            }) : this.getCustomItems().map(function (el) {
                return el.removeAttribute('tabindex', 0);
            });
        }
    }, {
        key: 'makeListAccessible',
        value: function makeListAccessible(e) {
            if (e.which === 13) this.toggleOptionsList();
        }
    }, {
        key: 'closeOptionsList',
        value: function closeOptionsList(e) {
            var parent = e.target.closest('.custom-select');
            if (!parent && this.listOpened) this.toggleOptionsList();
        }
    }, {
        key: 'checkFocused',
        value: function checkFocused(e) {
            var _this2 = this;

            setTimeout(function () {
                var currentEl = _this2.getCurrentFocusedEl();

                if (e.which === 9 && !_this2.body.contains(currentEl) && _this2.listOpened) _this2.toggleOptionsList();
            }, 150);
        }

        // Creating custom select element (markup)

    }, {
        key: 'createNewSelect',
        value: function createNewSelect() {
            this.createNewSelectedItem();
            this.createNewOptionsList();
        }
    }, {
        key: 'createNewSelectedItem',
        value: function createNewSelectedItem() {
            var label = this.el.parentElement.querySelector('label');
            var id = this.getCustomListId();
            var ariaLabel = label.querySelector('span').innerText;
            var newSelectItem = document.createElement('DIV');
            var innerText = this.selectElement.options[this.selectElement.selectedIndex].innerText;
            var ariaRequired = this.selectElement.getAttribute('aria-required');
            var ariaNotRequired = 'false';
            newSelectItem.setAttribute('role', 'combobox');
            newSelectItem.setAttribute('aria-autocomplete', 'list');
            newSelectItem.setAttribute('class', 'select-selected');
            newSelectItem.setAttribute('tabindex', 0);
            newSelectItem.setAttribute('aria-expanded', false);
            newSelectItem.setAttribute('aria-label', ariaLabel);
            newSelectItem.setAttribute('aria-required', ariaRequired !== null ? ariaRequired : ariaNotRequired);
            newSelectItem.setAttribute('aria-owns', id);
            newSelectItem.setAttribute('aria-activedescendant', 'selected_option' + '-' + id);

            this.createInnerSpan(newSelectItem, innerText);
            this.createArrowIcon(newSelectItem);

            this.el.appendChild(newSelectItem);
        }
    }, {
        key: 'createInnerSpan',
        value: function createInnerSpan(parent, text) {
            var innerSpan = document.createElement('SPAN');
            innerSpan.innerText = text;
            innerSpan.setAttribute('class', 'text');

            parent.appendChild(innerSpan);
        }
    }, {
        key: 'createArrowIcon',
        value: function createArrowIcon(newSelectItem) {
            var arrowIcon = document.createElement('SPAN');
            arrowIcon.setAttribute('class', 'arrow-icon');
            arrowIcon.setAttribute('aria-hidden', true);

            newSelectItem.appendChild(arrowIcon);
        }
    }, {
        key: 'createNewOptionsList',
        value: function createNewOptionsList() {
            var id = this.getCustomListId();
            var newOptionsContainer = document.createElement('DIV');
            newOptionsContainer.setAttribute('id', id);
            newOptionsContainer.setAttribute('role', 'listbox');
            newOptionsContainer.setAttribute('class', 'select-items select-hide');

            this.createNewOptions(newOptionsContainer);
            this.el.appendChild(newOptionsContainer);
        }
    }, {
        key: 'createNewOptions',
        value: function createNewOptions(newOptionsContainer) {
            var _this3 = this;

            var originalOptions = this.getOriginalOptions();

            originalOptions.forEach(function (el, index) {
                var newOption = document.createElement('DIV');
                var text = el.innerText;
                newOption.setAttribute('class', 'custom-item');
                newOption.setAttribute('role', 'option');
                _this3.addInnerSpan(newOption, text);

                if (el.innerText === _this3.getCustomSelectBox().innerText) {
                    newOption.classList.add('selected');
                    newOption.setAttribute('id', 'selected_option' + '-' + newOptionsContainer.getAttribute('id'));
                    newOption.setAttribute('aria-selected', true);
                }

                newOptionsContainer.appendChild(newOption);
                newOption.addEventListener('click', _this3.updateSelect.bind(_this3));
                newOption.addEventListener('keydown', _this3.updateSelect.bind(_this3));
            });
        }
    }, {
        key: 'addInnerSpan',
        value: function addInnerSpan(parent, text) {
            var innerSpan = document.createElement('SPAN');
            innerSpan.innerText = text;
            innerSpan.setAttribute('class', 'text');

            parent.appendChild(innerSpan);
        }
    }, {
        key: 'updateSelect',
        value: function updateSelect(e) {
            var _this4 = this;

            var canUpdate = this.canUpdate(e);

            if (canUpdate) {
                var target = e.target;

                this.getOriginalOptions().forEach(function (el, index) {
                    if (el.innerText === target.innerText) {
                        _this4.updateSelectedItem(target, index);
                        var event = document.createEvent('Event');
                        event.initEvent('change', false, true
                        /*  eslint-disable */
                        );_this4.selectElement.dispatchEvent(event
                        /*  eslint-enable */
                        );
                    }
                });

                if (this.listOpened) {
                    this.toggleOptionsList();
                    this.getCustomSelectBox().focus();
                }
            }
        }
    }, {
        key: 'canUpdate',
        value: function canUpdate(e) {
            return e.type === 'click' || e.type === 'keydown' && e.which === 13;
        }
    }, {
        key: 'updateSelectedItem',
        value: function updateSelectedItem(target, index) {
            this.updateSelectedIndex(index, target.innerText);
            this.updateSelectedItmesClass(target);
        }
    }, {
        key: 'updateSelectedIndex',
        value: function updateSelectedIndex(index, text) {
            var customSelectBox = this.getCustomSelectBox();

            this.selectElement.selectedIndex = index;
            customSelectBox.querySelector('.text').innerText = text;
        }
    }, {
        key: 'updateSelectedItmesClass',
        value: function updateSelectedItmesClass(target) {
            if (this.getCurrentSelect()) {
                this.getCurrentSelect().removeAttribute('aria-selected');
                this.getCurrentSelect().classList.remove('selected');
            }

            target.closest('.custom-item').classList.add('selected');
            target.setAttribute('aria-selected', true);
        }
    }, {
        key: 'getCustomListId',
        value: function getCustomListId() {
            var id = this.getSelectElement().getAttribute('id');
            return id + '-list';
        }

        // Get elements from the DOM

    }, {
        key: 'getForm',
        value: function getForm() {
            return this.el.closest('form');
        }
    }, {
        key: 'getBody',
        value: function getBody() {
            return document.querySelector('body');
        }
    }, {
        key: 'getSelectElement',
        value: function getSelectElement() {
            return this.el.querySelector('select');
        }
    }, {
        key: 'getOriginalOptions',
        value: function getOriginalOptions() {
            return Array.from(this.selectElement.querySelectorAll('option'));
        }
    }, {
        key: 'getCustomItems',
        value: function getCustomItems() {
            return Array.from(this.el.querySelectorAll('.custom-item'));
        }
    }, {
        key: 'getSelectListElement',
        value: function getSelectListElement() {
            return this.el.querySelector('.select-items');
        }
    }, {
        key: 'getCustomSelectBox',
        value: function getCustomSelectBox() {
            return this.el.querySelector('.select-selected');
        }
    }, {
        key: 'getCurrentSelect',
        value: function getCurrentSelect() {
            return this.el.querySelector('.selected');
        }
    }, {
        key: 'getCurrentFocusedEl',
        value: function getCurrentFocusedEl() {
            return this.el.querySelector(':focus');
        }
    }]);

    return CustomSelect;
}();

//* ----------------------------------------------------------------------------
//
//  This code creates a custom select div with custom options list (for styling)
//  that interacts with the original select element
//  Reference: https://www.w3schools.com/howto/howto_custom_select.asp
//
//* ----------------------------------------------------------------------------

var CustomSelectRadio = function () {
    function CustomSelectRadio(el) {
        _classCallCheck(this, CustomSelectRadio);

        if (el.querySelectorAll('.select-selected').length) return false;

        this.el = el;
        this.body = this.getBody();
        this.selectElement = this.getSelectElement();
        this.form = this.getForm();
        this.listOpened = false;

        this.createNewSelect();
        this.events();
    }

    _createClass(CustomSelectRadio, [{
        key: 'events',
        value: function events() {
            this.getCustomButton().addEventListener('click', this.submitForm.bind(this));
            this.getCustomSelectBox().addEventListener('click', this.toggleOptionsList.bind(this));
            this.getCustomSelectBox().addEventListener('keydown', this.toggleOptionsList.bind(this));
            this.body.addEventListener('keydown', this.checkFocused.bind(this));
            window.addEventListener('click', this.closeOptionsList.bind(this));
        }

        // Custom select element events and accessibility adaptations

    }, {
        key: 'toggleOptionsList',
        value: function toggleOptionsList(e) {
            var canInteract = this.canInteract(e);

            if (canInteract) {
                e.preventDefault();

                this.getSelectListElement().classList.toggle('select-hide');
                this.getCustomSelectBox().closest('.form-item > .inner').classList.toggle('is-opened');
                this.makeOptionsAccessible();
                this.listOpened ? this.getCustomSelectBox().setAttribute('aria-expanded', 'true') : this.getCustomSelectBox().setAttribute('aria-expanded', 'false');
            }
        }
    }, {
        key: 'makeOptionsAccessible',
        value: function makeOptionsAccessible() {
            this.listOpened = !this.listOpened;
        }
    }, {
        key: 'closeOptionsList',
        value: function closeOptionsList(e) {
            var parent = e.target.closest('.views-exposed-form .custom-select');
            if (!parent && this.listOpened) this.toggleOptionsList(e);
        }
    }, {
        key: 'checkFocused',
        value: function checkFocused(e) {
            var _this = this;

            setTimeout(function () {
                var currentEl = _this.getCurrentFocusedEl();

                if (e.which === 9 && !_this.body.contains(currentEl) && _this.listOpened) _this.toggleOptionsList(e);
            }, 150);
        }

        // Creating custom select element (markup)

    }, {
        key: 'createNewSelect',
        value: function createNewSelect() {
            this.createNewSelectedItem();
            this.createNewOptionsList();
        }
    }, {
        key: 'createNewSelectedItem',
        value: function createNewSelectedItem() {
            var newId = this.getCustomListId();
            var newSelectItem = document.createElement('DIV');
            var text = this.selectElement.options[this.selectElement.selectedIndex].innerHTML;
            newSelectItem.setAttribute('role', 'button');
            newSelectItem.setAttribute('class', 'select-selected');
            newSelectItem.setAttribute('tabindex', 0);
            newSelectItem.setAttribute('aria-expanded', 'false');
            newSelectItem.setAttribute('aria-controls', newId);

            this.createTextElement(newSelectItem, text);
            this.createArrowIcon(newSelectItem);
            this.el.appendChild(newSelectItem);
        }
    }, {
        key: 'createTextElement',
        value: function createTextElement(newSelectItem, text) {
            var textElement = document.createElement('SPAN');
            textElement.setAttribute('class', 'text');
            textElement.innerText = text;

            newSelectItem.appendChild(textElement);
        }
    }, {
        key: 'createArrowIcon',
        value: function createArrowIcon(newSelectItem) {
            var arrowIcon = document.createElement('SPAN');
            arrowIcon.setAttribute('class', 'arrow-icon');
            arrowIcon.setAttribute('aria-hidden', 'true');

            newSelectItem.appendChild(arrowIcon);
        }
    }, {
        key: 'createNewOptionsList',
        value: function createNewOptionsList() {
            var newId = this.getCustomListId();
            var newOptionsContainer = document.createElement('DIV');
            newOptionsContainer.setAttribute('id', newId);
            newOptionsContainer.setAttribute('class', 'select-items select-hide');

            var listButton = document.createElement('DIV');
            listButton.setAttribute('class', 'list-button');
            var submitButton = document.createElement('BUTTON');
            submitButton.innerText = 'Submit';
            submitButton.setAttribute('class', 'custom-button');

            this.createNewOptions(newOptionsContainer);
            listButton.appendChild(submitButton);
            newOptionsContainer.appendChild(listButton);
            this.el.appendChild(newOptionsContainer);
        }
    }, {
        key: 'createNewOptions',
        value: function createNewOptions(newOptionsContainer) {
            var _this2 = this;

            var originalOptions = this.getOriginalOptions();
            var groupLabel = this.el.parentElement.querySelector('label > span').innerText;
            var groupName = groupLabel.substring(0, groupLabel.length - 1).toLowerCase().split(' ').join('-');
            var body = document.createElement('FIELDSET');
            body.setAttribute('class', 'list-body');
            body.setAttribute('id', groupName);

            var legend = document.createElement('LEGEND');
            var label = document.createElement('SPAN');
            label.setAttribute('class', 'visually-hidden');
            label.innerText = groupLabel.substring(0, groupLabel.length - 1);
            legend.appendChild(label);
            body.appendChild(legend);

            originalOptions.forEach(function (el, index) {
                var id = el.innerText.toLowerCase().split(' ').join('-');
                var value = el.getAttribute('value');

                var newOption = document.createElement('DIV');
                newOption.setAttribute('class', 'custom-item');

                var newInput = document.createElement('INPUT');
                newInput.setAttribute('class', 'visually-hidden');
                newInput.classList.add('select-type');
                newInput.setAttribute('type', 'radio');
                newInput.setAttribute('id', id);
                newInput.setAttribute('value', value);
                newInput.setAttribute('name', 'select_type_option');

                var newLabel = document.createElement('LABEL');
                newLabel.setAttribute('for', id);
                _this2.addInnerRadioIcon(newLabel, el.innerText);
                _this2.addInnerSpan(newLabel, el.innerText);

                if (index === 0 && originalOptions.length > 1) {
                    newOption.classList.add('all-item');
                    newInput.checked = 'true';
                }

                newOption.appendChild(newInput);
                newOption.appendChild(newLabel);
                body.appendChild(newOption);

                newOption.addEventListener('mouseup', _this2.select.bind(_this2));
                newOption.addEventListener('keydown', _this2.navigateSelect.bind(_this2));
            });

            newOptionsContainer.appendChild(body);
        }
    }, {
        key: 'addInnerSpan',
        value: function addInnerSpan(parent, text) {
            var innerSpan = document.createElement('SPAN');
            innerSpan.innerText = text;
            innerSpan.setAttribute('class', 'text');

            parent.appendChild(innerSpan);
        }
    }, {
        key: 'addInnerRadioIcon',
        value: function addInnerRadioIcon(parent) {
            var innerRadioIcon = document.createElement('SPAN');
            innerRadioIcon.setAttribute('class', 'icon');
            innerRadioIcon.setAttribute('aria-hidden', 'true');

            parent.appendChild(innerRadioIcon);
        }
    }, {
        key: 'navigateSelect',
        value: function navigateSelect(e) {
            e.preventDefault();
            var target = e.target;

            if (e.which === 13 || e.which === 32) this.select(e);else if (e.which === 39 || e.which === 40) {
                var index = this.getCustomItems().indexOf(target.closest('.custom-item'));

                if (index === this.getCustomItems().length - 1) this.getCustomItems()[0].querySelector('input').focus();else this.getCustomItems()[index + 1].querySelector('input').focus();
            } else if (e.which === 37 || e.which === 38) {
                var _index = this.getCustomItems().indexOf(target.closest('.custom-item'));

                if (_index === 0) this.getCustomItems()[this.getCustomItems().length - 1].querySelector('input').focus();else this.getCustomItems()[_index - 1].querySelector('input').focus();
            } else if (e.shiftKey && e.which === 9) target.closest('.custom-select').querySelector('.select-selected').focus();else if (e.which === 9) target.closest('.select-items').querySelector('.custom-button').focus();
        }
    }, {
        key: 'select',
        value: function select(e) {
            var target = e.target;
            var index = this.getCustomItems().indexOf(target.closest('.custom-item'));

            target.checked = 'true';

            this.updateSelectedItem(target, index);
        }
    }, {
        key: 'canInteract',
        value: function canInteract(e) {
            return e.type === 'click' || e.type === 'keydown' && (e.which === 13 || e.which === 32);
        }
    }, {
        key: 'updateSelectedItem',
        value: function updateSelectedItem(target, index) {
            var customSelectBox = this.getCustomSelectBox();
            var text = this.getCustomItems()[index].querySelector('label .text').innerText;

            this.selectElement.selectedIndex = index;
            customSelectBox.querySelector('.text').innerHTML = text;
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            var target = e.target;

            target.closest('form').submit();
        }
    }, {
        key: 'getCustomListId',
        value: function getCustomListId() {
            var id = this.getSelectElement().getAttribute('id');
            return id + '-list';
        }

        // Get elements from the DOM

    }, {
        key: 'getForm',
        value: function getForm() {
            return this.el.closest('form');
        }
    }, {
        key: 'getBody',
        value: function getBody() {
            return document.querySelector('body');
        }
    }, {
        key: 'getSelectElement',
        value: function getSelectElement() {
            return this.el.querySelector('select');
        }
    }, {
        key: 'getOriginalOptions',
        value: function getOriginalOptions() {
            return Array.from(this.selectElement.querySelectorAll('option'));
        }
    }, {
        key: 'getCustomItems',
        value: function getCustomItems() {
            return Array.from(this.el.querySelectorAll('.custom-item'));
        }
    }, {
        key: 'getSelectListElement',
        value: function getSelectListElement() {
            return this.el.querySelector('.select-items');
        }
    }, {
        key: 'getCustomSelectBox',
        value: function getCustomSelectBox() {
            return this.el.querySelector('.select-selected');
        }
    }, {
        key: 'getIcon',
        value: function getIcon() {
            return this.el.querySelector('.icon');
        }
    }, {
        key: 'getCurrentSelect',
        value: function getCurrentSelect() {
            return this.el.querySelector('.selected');
        }
    }, {
        key: 'getCustomButton',
        value: function getCustomButton() {
            return this.el.querySelector('.custom-button');
        }
    }, {
        key: 'getCurrentFocusedEl',
        value: function getCurrentFocusedEl() {
            return this.el.querySelector(':focus');
        }
    }]);

    return CustomSelectRadio;
}();

//* ----------------------------------------------------------------------------
//
//  This code takes care of pager on archive pages (fixes)
//  - removes first and last link from pages items
//  - disables and enabled prev and next link on last or first page
//
//* ----------------------------------------------------------------------------

var Linkicons$1 = function () {
    function Linkicons(el) {
        _classCallCheck(this, Linkicons);

        this.el = el;
        this.firstLink = this.getFirstLink();
        this.lastLink = this.getLastLink();
        this.nextLink = this.getNextLink();
        this.prevLink = this.getPrevLink();
        this.items = this.getPagerItems();

        this.setUp();
    }

    _createClass(Linkicons, [{
        key: 'setUp',
        value: function setUp() {
            var activeText = this.getText(this.getActivePage());
            var firstText = this.getText(this.firstLink);
            var lastText = this.getText(this.lastLink);

            this.adjustIfLastOrFirst(activeText, firstText, lastText);
            this.removeFirstAndLastItems(firstText, lastText);
            this.markActivePage();
        }
    }, {
        key: 'adjustIfLastOrFirst',
        value: function adjustIfLastOrFirst(activeText, firstText, lastText) {
            if (activeText === firstText) {
                this.getActivePage().classList.remove('is-active');
                this.firstLink.classList.add('is-active');
                this.disableElement(this.prevLink);
            } else if (activeText === lastText) {
                this.getActivePage().classList.remove('is-active');
                this.lastLink.classList.add('is-active');
                this.disableElement(this.nextLink);
            }
        }
    }, {
        key: 'disableElement',
        value: function disableElement(el) {
            el.querySelector('a').setAttribute('aria-disabled', true);
            el.querySelector('a').setAttribute('tabindex', -1);
            el.querySelector('a').classList.add('disabled');
            el.querySelector('a').addEventListener('click', this.disable.bind(this));
        }
    }, {
        key: 'disable',
        value: function disable(e) {
            e.preventDefault();
        }
    }, {
        key: 'removeFirstAndLastItems',
        value: function removeFirstAndLastItems(firstText, lastText) {
            var _this = this;

            this.items.forEach(function (el) {
                if (_this.getText(el) === firstText || _this.getText(el) === lastText) el.classList.add('is-hidden');
            });
        }
    }, {
        key: 'markActivePage',
        value: function markActivePage() {
            this.getActivePage().querySelector('a').setAttribute('aria-current', 'page');
        }
    }, {
        key: 'getText',
        value: function getText(el) {
            return el.querySelector('.text').innerText;
        }
    }, {
        key: 'getActivePage',
        value: function getActivePage() {
            return this.el.querySelector('.is-active');
        }
    }, {
        key: 'getFirstLink',
        value: function getFirstLink() {
            return this.el.querySelector('.pager__item--first');
        }
    }, {
        key: 'getLastLink',
        value: function getLastLink() {
            return this.el.querySelector('.pager__item--last');
        }
    }, {
        key: 'getPrevLink',
        value: function getPrevLink() {
            return this.el.querySelector('.pager__item--previous');
        }
    }, {
        key: 'getNextLink',
        value: function getNextLink() {
            return this.el.querySelector('.pager__item--next');
        }
    }, {
        key: 'getPagerItems',
        value: function getPagerItems() {
            return Array.from(this.el.querySelectorAll('.single__item'));
        }
    }]);

    return Linkicons;
}();

var AddToCalendar = function () {
    function AddToCalendar(el) {
        _classCallCheck(this, AddToCalendar);

        this.el = el.closest('body');
        this.title = document.querySelector('h1').textContent;
        this.startDate = new Date(document.querySelector('.field-start-date time').getAttribute('datetime'));
        this.endDate = new Date(document.querySelector('.field-end-date time').getAttribute('datetime'));
        this.locationField = this.el.querySelector('.field-location');
        this.location = '';

        this.init();
    }

    _createClass(AddToCalendar, [{
        key: 'init',
        value: function init() {
            if (this.locationField) this.location = this.locationField.innerText;

            /*  eslint-disable */
            var myCalendar = createCalendar({
                /*  eslint-enable */
                options: {
                    class: 'events-info'
                },
                data: {
                    title: this.title,
                    start: this.startDate,
                    end: this.endDate,
                    address: this.location
                }
            });

            this.el.querySelector('.social-share .calendar').appendChild(myCalendar);
            this.fixMarkup();
        }
    }, {
        key: 'fixMarkup',
        value: function fixMarkup() {
            var _this = this;

            var instance = this.getInstance();
            var links = Array.from(instance.querySelectorAll('a'));

            instance.removeChild(instance.querySelector('input'));
            instance.removeChild(instance.querySelector('label'));

            links.forEach(function (el) {
                el.setAttribute('tabindex', -1);
                _this.redoLink(el);
            });

            this.makeUnorderedList(instance);
        }
    }, {
        key: 'redoLink',
        value: function redoLink(el) {
            var text = el.textContent;
            var parent = el.parentElement;
            var li = document.createElement('LI');

            var span = document.createElement('SPAN');
            span.setAttribute('class', 'visually-hidden');
            span.textContent = text;

            var icon = document.createElement('I');

            if (text === 'Google Calendar') icon.setAttribute('class', 'fab fa-google');else if (text === 'Yahoo! Calendar') icon.setAttribute('class', 'fab fa-yahoo');else if (text === 'iCal Calendar') icon.setAttribute('class', 'fab fa-apple');else if (text === 'Outlook Calendar') icon.setAttribute('class', 'icon-Outlook_Icon');

            el.textContent = '';
            icon.setAttribute('aria-hidden', 'true');
            el.appendChild(span);
            el.appendChild(icon);

            li.appendChild(el);
            parent.appendChild(li);
        }
    }, {
        key: 'makeUnorderedList',
        value: function makeUnorderedList(instance) {
            var id = instance.getAttribute('id');
            var classes = instance.getAttribute('class');
            var ul = document.createElement('UL');
            var parent = instance.parentElement;
            var content = instance.innerHTML;
            ul.setAttribute('id', id);
            ul.setAttribute('class', classes);
            ul.innerHTML = content;
            parent.replaceChild(ul, instance);
        }
    }, {
        key: 'getInstance',
        value: function getInstance() {
            return this.el.querySelector('.add-to-calendar');
        }
    }]);

    return AddToCalendar;
}();

var AddToCalendars = function () {
    function AddToCalendars(el) {
        _classCallCheck(this, AddToCalendars);

        this.el = el;
        this.title = this.el.querySelector('h2').textContent;
        this.startDate = new Date(this.el.querySelector('.field-start-date time').getAttribute('datetime'));
        this.endDate = new Date(this.el.querySelector('.field-end-date time').getAttribute('datetime'));
        this.locationField = this.el.querySelector('.field-location');
        this.location = '';

        this.init();
    }

    _createClass(AddToCalendars, [{
        key: 'init',
        value: function init() {
            if (this.locationField) this.location = this.locationField.innerText;

            /*  eslint-disable */
            var myCalendar = createCalendar({
                /*  eslint-enable */
                options: {
                    class: 'calendar-wrap'
                },
                data: {
                    title: this.title,
                    start: this.startDate,
                    end: this.endDate,
                    address: this.location
                }
            });

            this.el.querySelector('.social-share .calendar').appendChild(myCalendar);
            this.fixMarkup();
            this.setAria();
        }
    }, {
        key: 'fixMarkup',
        value: function fixMarkup() {
            var _this = this;

            var instance = this.getInstance();
            var links = Array.from(instance.querySelectorAll('a'));

            instance.removeChild(instance.querySelector('input'));
            instance.removeChild(instance.querySelector('label'));

            links.forEach(function (el) {
                el.setAttribute('tabindex', -1);
                _this.redoLink(el);
            });

            this.makeUnorderedList(instance);
        }
    }, {
        key: 'redoLink',
        value: function redoLink(el) {
            var text = el.textContent;
            var parent = el.parentElement;
            var li = document.createElement('LI');

            var span = document.createElement('SPAN');
            span.setAttribute('class', 'visually-hidden');
            span.textContent = text;

            var icon = document.createElement('I');

            if (text === 'Google Calendar') icon.setAttribute('class', 'fab fa-google');else if (text === 'Yahoo! Calendar') icon.setAttribute('class', 'fab fa-yahoo');else if (text === 'iCal Calendar') icon.setAttribute('class', 'fab fa-apple');else if (text === 'Outlook Calendar') icon.setAttribute('class', 'icon-Outlook_Icon');

            el.textContent = '';
            icon.setAttribute('aria-hidden', 'true');
            el.appendChild(span);
            el.appendChild(icon);

            li.appendChild(el);
            parent.appendChild(li);
        }
    }, {
        key: 'setAria',
        value: function setAria() {
            var share = this.el.querySelectorAll('.social-share');

            share.forEach(function (el) {
                var heading = el.parentElement.querySelector('.content .inner a h2').getAttribute('id');
                el.querySelectorAll('.share-button').forEach(function (el) {
                    el.setAttribute('aria-describedby', heading);
                });
            });
        }
    }, {
        key: 'makeUnorderedList',
        value: function makeUnorderedList(instance) {
            var id = instance.getAttribute('id');
            var classes = instance.getAttribute('class');
            var ul = document.createElement('UL');
            var parent = instance.parentElement;
            var content = instance.innerHTML;
            ul.setAttribute('id', id);
            ul.setAttribute('class', classes);
            ul.innerHTML = content;
            parent.replaceChild(ul, instance);
        }
    }, {
        key: 'getInstance',
        value: function getInstance() {
            return this.el.querySelector('.add-to-calendar');
        }
    }]);

    return AddToCalendars;
}();

var Search = function () {
    function Search() {
        _classCallCheck(this, Search);

        this.body = this.getBody();
        this.searchButton = this.getSearchButton();
        this.closeButton = this.getCloseButton();
        this.searchModule = this.getSearchModule();
        this.searchInput = this.getSearchInput();
        this.searchPage = this.getSearchPage();
        this.headerSubmitButton = this.getHeaderSubmitButton();
        this.sections = this.getSections();
        this.isOpened = 0;

        if (this.searchModule) this.events();
    }

    _createClass(Search, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.searchButton.forEach(function (el) {
                el.addEventListener('click', _this.openSearch.bind(_this));
            });
            this.closeButton.addEventListener('click', this.closeSearch.bind(this));
            this.body.addEventListener('keydown', this.closeSearch.bind(this));
            this.headerSubmitButton.addEventListener('click', this.toggleSearch.bind(this));
        }

        // Call the function when the part of the page gets focus

    }, {
        key: 'openSearch',
        value: function openSearch(e) {
            var _this2 = this;

            this.searchModule.classList.add('is-opened');
            disableBodyScroll(this.body);
            this.searchModule.setAttribute('role', 'dialog');
            setTimeout(function () {
                return _this2.searchInput.focus();
            }, 1000);
            this.isOpened = 1;
            this.setSiblingVisibility();
        }
    }, {
        key: 'closeSearch',
        value: function closeSearch(e) {
            if (!this.isOpened) return;

            if (e.type === 'click' || e.type === 'keydown' && e.which === 27) {
                this.close();
                this.searchModule.removeAttribute('role', 'dialog');
                this.setSiblingVisibility();
            }
        }
    }, {
        key: 'close',
        value: function close() {
            var _this3 = this;

            this.searchModule.classList.remove('is-opened');
            this.searchModule.classList.add('is-closing');
            setTimeout(function () {
                return _this3.searchModule.classList.remove('is-closing');
            }, 700);
            enableBodyScroll(this.body);
            clearAllBodyScrollLocks();

            this.body.classList.contains('is-small') ? this.searchButton[1].focus() : this.searchButton[0].focus();

            this.isOpened = 0;
        }
    }, {
        key: 'toggleSearch',
        value: function toggleSearch() {
            if (this.searchPage && this.isOpened) this.close();
        }
    }, {
        key: 'getBody',
        value: function getBody() {
            return document.querySelector('body');
        }
    }, {
        key: 'getSections',
        value: function getSections() {
            return Array.from(document.querySelectorAll('.region-alert, header, section, main, footer'));
        }
    }, {
        key: 'getSearchButton',
        value: function getSearchButton() {
            return Array.from(document.querySelectorAll('.js-open-search'));
        }
    }, {
        key: 'getHeaderSubmitButton',
        value: function getHeaderSubmitButton() {
            return document.querySelector('.region-search .submit-item input');
        }
    }, {
        key: 'getSearchPage',
        value: function getSearchPage() {
            return document.querySelector('.path-search');
        }
    }, {
        key: 'getCloseButton',
        value: function getCloseButton() {
            return document.querySelector('.js-close-search');
        }
    }, {
        key: 'getSearchModule',
        value: function getSearchModule() {
            return document.querySelector('.region-search');
        }
    }, {
        key: 'getSearchInput',
        value: function getSearchInput() {
            return document.querySelector('.region-search .js-form-item-search-api-fulltext input');
        }
    }, {
        key: 'setSiblingVisibility',
        value: function setSiblingVisibility() {
            var isOpened = this.searchModule && this.searchModule.classList.contains('is-opened');

            Array.from(document.querySelectorAll(['.skip-index', 'header', 'main', 'footer', '.region-alert', '.region-search', '#sliding-popup'].join(', '))).forEach(function (el) {
                if (!el.tagName.match(/header/i)) {
                    if (isOpened && el.getAttribute('aria-hidden') !== 'true') el.getAttribute('aria-hidden');

                    if (!isOpened && el.getAttribute('aria-hidden')) el.removeAttribute('aria-hidden');

                    return;
                }

                if (isOpened && !el.classList.contains('hidden') || !isOpened && el.classList.contains('hidden')) el.classList.toggle('hidden');
            });
        }
    }]);

    return Search;
}();

//* ----------------------------------------------------------------------------
//
//  This code takes care of clear button on search input
//  - shows when input is not empty
//  - reset value on click
//
//* ----------------------------------------------------------------------------

var SearchInput = function () {
    function SearchInput(el) {
        _classCallCheck(this, SearchInput);

        this.el = el;
        this.input = this.getInput();
        this.clearButton = this.getClearButton();
        this.form = this.getForm();
        this.hasValue = 0;
        this.buttonShown = 0;

        this.checkIfInputEmpty();
        this.events();
    }

    _createClass(SearchInput, [{
        key: 'events',
        value: function events() {
            this.input.addEventListener('keyup', this.updateValue.bind(this));
            this.input.addEventListener('keypress', this.preventClear.bind(this));
            this.clearButton.addEventListener('click', this.emptyValue.bind(this));
            this.clearButton.addEventListener('keypress', this.emptyValue.bind(this));
        }
    }, {
        key: 'checkIfInputEmpty',
        value: function checkIfInputEmpty() {
            if (this.input.value) this.showButton();
        }
    }, {
        key: 'updateValue',
        value: function updateValue(e) {
            this.input.value ? this.hasValue = 1 : this.hasValue = 0;

            if (this.hasValue && !this.buttonShown) this.showButton();else if (!this.hasValue && this.buttonShown) this.hideButton();

            if (e.which === 13 && !this.el.closest('.library-search-form')) this.form.querySelector('.js-form-submit').click();
        }
    }, {
        key: 'preventClear',
        value: function preventClear(e) {
            if (e.which === 13) e.preventDefault();
        }
    }, {
        key: 'showButton',
        value: function showButton() {
            this.clearButton.classList.remove('is-hidden');
            this.buttonShown = 1;
        }
    }, {
        key: 'hideButton',
        value: function hideButton() {
            this.clearButton.classList.add('is-hidden');
            this.buttonShown = 0;
        }
    }, {
        key: 'emptyValue',
        value: function emptyValue(e) {
            var _this = this;

            e.preventDefault();

            if (e.type === 'click' || e.type === 'keypress' && e.which === 13) {
                this.input.value = '';
                this.hideButton();

                if (e.type === 'click') this.input.focus();else setTimeout(function () {
                    return _this.input.focus();
                }, 200);
            }
        }
    }, {
        key: 'getInput',
        value: function getInput() {
            return this.el.querySelector('input');
        }
    }, {
        key: 'getClearButton',
        value: function getClearButton() {
            return this.el.querySelector('.js-clear-input');
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            return this.el.closest('form');
        }
    }]);

    return SearchInput;
}();

//* ----------------------------------------------------------------------------
//
//  This code scrolls focused element into view if
//  - sticky header is covering it and/or
//  - cookie banner is covering it
//
//* ----------------------------------------------------------------------------

var FocusCorrect = function () {
    function FocusCorrect() {
        _classCallCheck(this, FocusCorrect);

        this.events();
    }

    _createClass(FocusCorrect, [{
        key: 'events',
        value: function events() {
            var _this = this;

            var focusListeners = function focusListeners() {
                _this.getFocusableElements().filter(function (el) {
                    return !el._focus_correct;
                }).forEach(function (el) {
                    el._focus_correct = true;
                    el.addEventListener('focus', function (e) {
                        return setTimeout(function () {
                            return _this.scrollToView(e);
                        }, 100);
                    });
                });
            };

            focusListeners();

            if (!('MutationObserver' in window)) return;

            // Watch for admin toolbar height changes
            new window.MutationObserver(function () {
                return focusListeners();
            }).observe(document.body, { childList: true, subtree: true });
        }
    }, {
        key: 'scrollToView',
        value: function scrollToView(e) {
            var el = e.target;

            if (el !== document.activeElement || el.classList.contains('visually-hidden') && !el.classList.contains('focusable')) return;

            var topOffset = this.getTopOffset();
            var bottomOffset = window.innerHeight - (this.getCookieBanner() ? this.getCookieBanner().clientHeight : 0);

            if (!topOffset && bottomOffset === window.innerHeight) return;

            var bounds = el.getBoundingClientRect();
            var boundsBottom = bounds.top + el.clientHeight;

            var scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

            var scrollToYOffset = 30;

            if (bounds.top < topOffset && boundsBottom < bottomOffset) return window.scrollTo(0, Math.floor(scrollY - (topOffset - bounds.top + scrollToYOffset)));

            if (boundsBottom > bottomOffset && bounds.top > topOffset) return window.scrollTo(0, Math.round(scrollY + bounds.top - (topOffset + scrollToYOffset)));
        }
    }, {
        key: 'isLargeViewport',
        value: function isLargeViewport() {
            return document.body.classList.contains('is-big');
        }
    }, {
        key: 'isStickyHeader',
        value: function isStickyHeader() {
            return this.isLargeViewport() && document.querySelector('header') && document.querySelector('header').classList.contains('sticky');
        }
    }, {
        key: 'getBodyPadding',
        value: function getBodyPadding() {
            return Number(document.body.style.paddingTop.replace(/\D/g, '') || '0');
        }
    }, {
        key: 'getStickyHeader',
        value: function getStickyHeader() {
            return this.isLargeViewport() ? document.querySelector('#block-menubar-clone') : document.querySelector('#block-menubar');
        }
    }, {
        key: 'getBreadcrumbs',
        value: function getBreadcrumbs() {
            return document.querySelector('.sticky-breadcrumbs');
        }
    }, {
        key: 'getCookieBanner',
        value: function getCookieBanner() {
            return document.querySelector('.sliding-popup-bottom');
        }
    }, {
        key: 'getMobilemenu',
        value: function getMobilemenu() {
            return document.querySelector('#block-mobilemenu');
        }
    }, {
        key: 'getAdminToolbar',
        value: function getAdminToolbar() {
            return document.querySelector('#toolbar-administration');
        }
    }, {
        key: 'getTopOffset',
        value: function getTopOffset() {
            return this.getBodyPadding() + (!this.isLargeViewport() || this.isStickyHeader() ? this.getStickyHeader().clientHeight : 0) + (this.isLargeViewport() && this.getBreadcrumbs() && this.getBreadcrumbs().classList.contains('sticky') ? this.getBreadcrumbs().clientHeight : 0);
        }
    }, {
        key: 'getFocusableElements',
        value: function getFocusableElements() {
            var _this2 = this;

            return Array.from(document.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function (el) {
                return !(_this2.getCookieBanner() && _this2.getCookieBanner().contains(el)) && !(_this2.getMobilemenu() && _this2.getMobilemenu().contains(el)) && !(_this2.getAdminToolbar() && _this2.getAdminToolbar().contains(el));
            });
        }
    }]);

    return FocusCorrect;
}();

//
//  This code makes cookiner unsticky
//  after it reaches footer section
//
//* ----------------------------------------------------------------------------

var CookieBanner = function () {
    function CookieBanner() {
        _classCallCheck(this, CookieBanner);

        if (!this.getCookieBanner()) return;

        this.render();
        this.events();
    }

    _createClass(CookieBanner, [{
        key: 'events',
        value: function events() {
            var _this = this;

            window.addEventListener('resize', function () {
                return _this.render();
            });

            if (!('MutationObserver' in window)) return;

            // Watch for admin toolbar height changes
            new window.MutationObserver(function (mutations) {
                return _this.render();
            }).observe(document.body, {
                attributes: true,
                childList: true
            });
        }
    }, {
        key: 'getFooter',
        value: function getFooter() {
            return document.querySelector('footer');
        }
    }, {
        key: 'getRegionContent',
        value: function getRegionContent() {
            return document.querySelector('.region-content');
        }
    }, {
        key: 'getCookieBanner',
        value: function getCookieBanner() {
            return document.querySelector('.sliding-popup-bottom');
        }
    }, {
        key: 'render',
        value: function render() {
            var targetEl = this.getFooter() || this.getRegionContent();

            if (!this.getCookieBanner() || !targetEl) return targetEl && targetEl.style.paddingBottom ? function () {
                targetEl.style.paddingBottom = '';
            }() : null;

            var maxWidth = document.querySelector('main') ? document.querySelector('main').clientWidth + 'px' : '100%';

            if (this.getCookieBanner().style.maxWidth !== maxWidth) this.getCookieBanner().style.maxWidth = maxWidth;

            var cookieBannerHeight = this.getCookieBanner().clientHeight + 'px';

            if (targetEl && targetEl.style.paddingBottom !== cookieBannerHeight) targetEl.style.paddingBottom = cookieBannerHeight;
        }
    }]);

    return CookieBanner;
}();

//* ----------------------------------------------------------------------------
//
//  This code takes care of custom video controls functionality (homepage hero):
//  - plays video
//  - pauses video
//
//* ----------------------------------------------------------------------------

var CustomVideoControls = function () {
    function CustomVideoControls(el) {
        _classCallCheck(this, CustomVideoControls);

        this.video = this.getVideo();

        if (this.video) {
            this.playVideo();
            this.events();
        }
    }

    _createClass(CustomVideoControls, [{
        key: 'events',
        value: function events() {
            this.getControlButton().addEventListener('click', this.controlVideo.bind(this));
        }
    }, {
        key: 'playVideo',
        value: function playVideo() {
            this.video.play();
            this.checkIfVideoWorks();
        }
    }, {
        key: 'checkIfVideoWorks',
        value: function checkIfVideoWorks() {
            var _this = this;

            this.video.onplaying = function () {
                _this.getControlWrapper().classList.remove('controls-hidden');
            };
        }
    }, {
        key: 'controlVideo',
        value: function controlVideo() {
            var text = this.getControlButton().querySelector('span').innerText;
            var method = text.toLowerCase() === 'play video' ? 'play' : 'pause';

            this.action(method);
            this.updateControl(method);
        }
    }, {
        key: 'action',
        value: function action(method) {
            method === 'play' ? this.video.play() : this.video.pause();
        }
    }, {
        key: 'updateControl',
        value: function updateControl(method) {
            if (method === 'play') {
                this.getControlButton().querySelector('i').innerText = 'pause';
                this.getControlButton().querySelector('span').innerText = 'pause video';
            } else {
                this.getControlButton().querySelector('i').innerText = 'play_arrow';
                this.getControlButton().querySelector('span').innerText = 'play video';
            }
        }
    }, {
        key: 'getVideo',
        value: function getVideo() {
            return document.querySelector('.js-hero-video');
        }
    }, {
        key: 'getControlButton',
        value: function getControlButton() {
            return document.querySelector('.js-control-bg-video');
        }
    }, {
        key: 'getControlWrapper',
        value: function getControlWrapper() {
            return this.getControlButton().closest('.wrapper');
        }
    }]);

    return CustomVideoControls;
}();

//* ----------------------------------------------------------------------------
//
//  This code is a links -
//  it associates them with relevent heading
//
//* ----------------------------------------------------------------------------

var LinkAria = function () {
    function LinkAria() {
        _classCallCheck(this, LinkAria);

        this.setAria();
    }

    _createClass(LinkAria, [{
        key: 'setAria',
        value: function setAria() {
            var links = Array.from(document.querySelectorAll('.paragraph--type--assets-download-item'));

            links.forEach(function (el) {
                var heading = el.querySelector('.field-file-title');
                var linkInfo = el.querySelector('.link-info');

                if (!heading || !linkInfo) return;

                el.querySelector('.link-info').innerText = heading.innerText;
            });
        }
    }]);

    return LinkAria;
}();

//* ----------------------------------------------------------------------------
//
//  This code takes care of keeping focus inside modal
//
//* ----------------------------------------------------------------------------

var ModalsFocus = function () {
    function ModalsFocus() {
        _classCallCheck(this, ModalsFocus);

        this.searchModule = this.getSearchModule();
        this.imageSlideshow = this.getImageSlideshow();

        if (this.searchModule || this.imageSlideshow) this.events();
    }

    _createClass(ModalsFocus, [{
        key: 'events',
        value: function events() {
            function trapFocus(element) {
                var allTabbableElements = 'a[href], area[href], input:not([disabled]),' + 'button:not([disabled]), iframe, object, embed, *[tabindex],' + '*[contenteditable]';
                var elements = element.querySelectorAll(allTabbableElements);
                var firstEl = elements[0];
                var lastEl = elements[elements.length - 1];
                var KEYCODE_TAB = 9;

                element.addEventListener('keydown', function (e) {
                    var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

                    if (!isTabPressed) return;

                    if (e.shiftKey) {
                        /* shift + tab */
                        if (document.activeElement === firstEl) {
                            lastEl.focus();
                            e.preventDefault();
                        }
                    } else if (document.activeElement === lastEl) {
                        firstEl.focus();
                        e.preventDefault();
                    }
                });
            }
            trapFocus(this.searchModule);
            trapFocus(this.imageSlideshow);
        }
    }, {
        key: 'getSearchModule',
        value: function getSearchModule() {
            return document.querySelector('.region-search');
        }
    }, {
        key: 'getImageSlideshow',
        value: function getImageSlideshow() {
            return document.querySelector('.pswp__ui');
        }
    }]);

    return ModalsFocus;
}();

//* ----------------------------------------------------------------------------
//
//  This code takes care of the search form
//  in library header:
//  - changing content based on active tabs
//  - redirecting to related links on submit
//
//* ----------------------------------------------------------------------------

var LibraryForm = function () {
    function LibraryForm() {
        _classCallCheck(this, LibraryForm);

        if (this.getLibraryHero()) {
            this.el = this.getLibraryHero();
            this.activeTabIndex = 0;
            this.link = '';
            this.events();
        }
    }

    _createClass(LibraryForm, [{
        key: 'events',
        value: function events() {
            var _this = this;

            this.getTabs().forEach(function (el) {
                el.addEventListener('click', _this.switchTab.bind(_this));
                el.addEventListener('keydown', _this.navigateTabs.bind(_this));
            });

            this.getForm().addEventListener('submit', this.redirect.bind(this));
            this.getSearchInput().addEventListener('keyup', this.redirect.bind(this));
        }
    }, {
        key: 'switchTab',
        value: function switchTab(e) {
            var target = e.target.closest('.tab');

            if (!target.classList.contains('active')) {
                this.deactivateTab();
                this.activateTab(target);
            }
        }
    }, {
        key: 'navigateTabs',
        value: function navigateTabs(e) {
            // Do the arrow logic
            if (e.keyCode === 39) this.goToNext(e.target);else if (e.keyCode === 37) this.goToPrev(e.target);
        }
    }, {
        key: 'goToNext',
        value: function goToNext(el) {
            var currentIndex = this.getTabs().indexOf(el);

            if (currentIndex + 1 < this.getTabs().length) {
                this.getTabs()[currentIndex + 1].setAttribute('tabindex', 0);
                this.getTabs()[currentIndex + 1].focus();
                this.getTabs()[currentIndex].removeAttribute('tabindex');
                this.deactivateTab();
                this.activateTab(this.getTabs()[currentIndex + 1]);
                this.activeTabIndex = currentIndex + 1;
            } else {
                this.getTabs()[0].setAttribute('tabindex', 0);
                this.getTabs()[0].focus();
                this.getTabs()[this.getTabs().length - 1].removeAttribute('tabindex');
                this.deactivateTab();
                this.activateTab(this.getTabs()[0]);
                this.activeTabIndex = 0;
            }
        }
    }, {
        key: 'goToPrev',
        value: function goToPrev(el) {
            var currentIndex = this.getTabs().indexOf(el);

            if (currentIndex > 0) {
                this.deactivateTab();
                this.activateTab(this.getTabs()[currentIndex - 1]);
                this.getTabs()[currentIndex - 1].focus();
                this.getTabs()[currentIndex].removeAttribute('tabindex');
                this.activeTabIndex = currentIndex - 1;
            } else {
                this.deactivateTab();
                this.activateTab(this.getTabs()[this.getTabs().length - 1]);
                this.getTabs()[this.getTabs().length - 1].focus();
                this.getTabs()[0].removeAttribute('tabindex');
                this.activeTabIndex = this.getTabs().length - 1;
            }
        }
    }, {
        key: 'getCanSubmit',
        value: function getCanSubmit(e) {
            return e.type === 'submit' || e.type === 'keyup' && e.which === 13;
        }
    }, {
        key: 'deactivateTab',
        value: function deactivateTab() {
            this.getTabs()[this.activeTabIndex].classList.remove('active');
            this.getTabs()[this.activeTabIndex].setAttribute('aria-selected', 'false');
            this.getTabs()[this.activeTabIndex].removeAttribute('tabinex');
            if (this.getSearchTextsMobile()[this.activeTabIndex]) this.getSearchTextsMobile()[this.activeTabIndex].classList.remove('active');
            if (this.getSearchTextsDesktop()[this.activeTabIndex]) this.getSearchTextsDesktop()[this.activeTabIndex].classList.remove('active');
            if (this.getLinks()[this.activeTabIndex]) this.getLinks()[this.activeTabIndex].classList.remove('active');
        }
    }, {
        key: 'activateTab',
        value: function activateTab(target) {
            var index = this.getIndexOf(target, this.getTabs());

            target.classList.add('active');
            target.setAttribute('tabindex', 0
            // Set aria-labelledby from tabs.
            );var tabId = this.getActiveTab().querySelector('span').getAttribute('id');
            this.getTabPanel().setAttribute('aria-labelledby', tabId
            // Change id depending on the tab.
            );var panelId = this.getActiveTab().querySelector('span').getAttribute('aria-controls');
            this.getTabPanel().setAttribute('id', panelId);
            this.getActiveTab().setAttribute('aria-selected', 'true');

            if (this.getSearchTextsMobile()[index]) {
                this.getSearchTextsMobile()[index].classList.add('active'
                // Set the aria-describedby label from text id.
                );var id = this.getSearchTextsMobile()[index].getAttribute('id');
                this.getForm().querySelector('input').setAttribute('aria-describedby', id);
            }
            if (this.getSearchTextsDesktop()[index]) {
                this.getSearchTextsDesktop()[index].classList.add('active'
                // Set the aria-describedby label from text id.
                );var _id = this.getSearchTextsDesktop()[index].getAttribute('id');
                this.getForm().querySelector('input').setAttribute('aria-describedby', _id);
            }
            if (this.getLinks()[index]) this.getLinks()[index].classList.add('active');
            this.activeTabIndex = index;
        }
    }, {
        key: 'redirect',
        value: function redirect(e) {
            e.preventDefault();

            var canSubmit = this.getCanSubmit(e);
            var term = encodeURIComponent(this.getSearchInput().value);
            var activeTab = this.getActiveTab().getAttribute('data-tab-value');

            if (canSubmit) {
                this.createLink(activeTab, term);
                this.openInNewTab();
            }
        }
        // https://research.ebsco.com/c/z63j24/search/results?q=test

    }, {
        key: 'createLink',
        value: function createLink(activeTab, term) {
            if (activeTab === 'catalog') this.link = 'https://research.ebsco.com/c/z63j24/search/results?acr_values=ip,guest&q=' + term;else if (activeTab === 'a_z_databases') this.link = 'https://cardozolaw.libguides.com/az.php?q=' + term;else if (activeTab === 'journals') this.link = 'https://publications.ebsco.com/?custId=ns274252&groupId=main&profileId=pfui&orderBy=relevance&search=' + term;else if (activeTab === 'course') this.link = 'https://yu.locate.ebsco.com/course-reserves?search=' + term;else if (activeTab === 'larc') this.link = 'https://larc.cardozo.yu.edu/do/search/?q=' + term + '&start=0&context=9495897&facet=';
        }
    }, {
        key: 'openInNewTab',
        value: function openInNewTab() {
            var win = window.open(this.link, '_blank');
            win.focus();
        }
    }, {
        key: 'getIndexOf',
        value: function getIndexOf(el, array) {
            return array.indexOf(el);
        }
    }, {
        key: 'getLibraryHero',
        value: function getLibraryHero() {
            return document.querySelector('.library-hero');
        }
    }, {
        key: 'getTabs',
        value: function getTabs() {
            return Array.from(this.el.querySelectorAll('.tab'));
        }
    }, {
        key: 'getActiveTab',
        value: function getActiveTab() {
            return this.el.querySelector('.tab.active');
        }
    }, {
        key: 'getSpans',
        value: function getSpans() {
            return Array.from(this.el.querySelectorAll('.tab span'));
        }
    }, {
        key: 'getSearchTextsMobile',
        value: function getSearchTextsMobile() {
            return Array.from(this.el.querySelectorAll('.description.desc-mobile > div'));
        }
    }, {
        key: 'getSearchTextsDesktop',
        value: function getSearchTextsDesktop() {
            return Array.from(this.el.querySelectorAll('.description.desc-desktop > div'));
        }
    }, {
        key: 'getLinks',
        value: function getLinks() {
            return Array.from(this.el.querySelectorAll('.form-extra .extra-link a'));
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            return this.el.querySelector('.library-search-form');
        }
    }, {
        key: 'getSearchInput',
        value: function getSearchInput() {
            return this.el.querySelector('.js-form-type-search input');
        }
    }, {
        key: 'getTabPanel',
        value: function getTabPanel() {
            return this.el.querySelector('.tabpanel');
        }
    }]);

    return LibraryForm;
}();

//* ----------------------------------------------------------------------------
//
//  This code takes care of webforms functionality
//  - form validation field on focusout
//  - set datepicker icon image
//  - adss custom resizer to textfield
//
//* ----------------------------------------------------------------------------

var Webform = function () {
    function Webform(el) {
        var _this = this;

        _classCallCheck(this, Webform);

        this.document = document;
        this.el = el;
        this.required = this.getRequired();
        this.fields = this.getFields();
        this.msg = this.msg();
        this.errorMsg = this.getErrorMsg();
        this.datepicker = this.getDatepicker();
        this.customFields = this.getCustomFields();
        setTimeout(function () {
            _this.datepickerTrigger = _this.getDatepickerTrigger();
        }, 100);

        this.events();
        this.setIdData();
        this.removeClass();
        this.removeAriaRequired();
        this.addRole();
        this.setAriaDescribedBy();
        this.replaceLabel();
        this.setAccessibleCalendarImg();
        this.setAccessiblePhoneField();
        this.setIcon();
        this.getTooltip();
        this.setIDPhonePrefix();
        this.setAccessibleCustomSelect();
        this.setAccessibleErrorForm();
        this.setBtnFocus();
        this.placeholderActive();
        this.alertMessages();
    }

    _createClass(Webform, [{
        key: 'events',
        value: function events() {
            var _this2 = this;

            this.required.forEach(function (el) {
                el.addEventListener('focusout', _this2.validate.bind(_this2));
            });
            this.fields.forEach(function (el) {
                el.addEventListener('focusout', _this2.setColor.bind(_this2));
            });
            this.customFields.forEach(function (el) {
                el.addEventListener('click', _this2.setFilled.bind(_this2));
            });
            setTimeout(function () {
                _this2.datepickerTrigger.forEach(function (el) {
                    el.addEventListener('click', _this2.moveDatepicker.bind(_this2));
                    el.addEventListener('click', _this2.setAria.bind(_this2));
                    el.addEventListener('focus', _this2.setAria.bind(_this2), true);
                    el.addEventListener('focus', _this2.moveDatepicker.bind(_this2));
                    el.addEventListener('click', _this2.setRoleApplication.bind(_this2));
                    el.addEventListener('focus', _this2.setRoleApplication.bind(_this2));
                    el.addEventListener('click', _this2.setTableRoles.bind(_this2));
                    el.addEventListener('focus', _this2.setTableRoles.bind(_this2));
                    el.addEventListener('click', _this2.setTableAria.bind(_this2));
                    el.addEventListener('focus', _this2.setTableAria.bind(_this2));
                    el.addEventListener('click', _this2.setPrevNextMonth.bind(_this2));
                    el.addEventListener('focus', _this2.setPrevNextMonth.bind(_this2));
                    el.addEventListener('focus', _this2.setNavigation.bind(_this2));
                    el.addEventListener('click', _this2.setNavigation.bind(_this2));
                    el.addEventListener('focus', _this2.datepickerNavigation.bind(_this2));
                    el.addEventListener('click', _this2.datepickerNavigation.bind(_this2));
                });
            }, 150);

            window.addEventListener('DOMContentLoaded', this.setIcon.bind(this));

            this.customTxtArea();
        }
    }, {
        key: 'setNavigation',
        value: function setNavigation() {
            var _this3 = this;

            setTimeout(function () {
                var today = _this3.document.querySelector('.ui-datepicker-today a');
                if (!today) today = _this3.document.querySelector('.ui-state-active') || _this3.document.querySelector('.ui-state-default');
                today.focus();
            });
        }
    }, {
        key: 'setRoleApplication',
        value: function setRoleApplication() {
            var datepicker = this.document.querySelector('.ui-datepicker');
            datepicker.setAttribute('role', 'application');
            datepicker.setAttribute('aria-label', 'Choose a date');
        }
    }, {
        key: 'setPrevNextMonth',
        value: function setPrevNextMonth() {
            var year = this.document.querySelectorAll('.ui-datepicker-year')[0].innerText;
            var month = this.document.querySelectorAll('.ui-datepicker-month')[0].innerText;

            var firstofmonth = month + '/1/' + year;
            var current = new Date(firstofmonth);
            var nextMonth = current.getMonth() + 1;
            var prevMonth = current.getMonth() - 1;

            var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

            if (prevMonth < 0) {
                prevMonth = 11;
                year = current.getFullYear() - 1;
            } else if (nextMonth > 11) {
                nextMonth = 0;
                year = current.getFullYear() + 1;
            }

            var nextButton = this.document.querySelector('.ui-datepicker-next');
            var prevButton = this.document.querySelector('.ui-datepicker-prev');
            nextButton.setAttribute('aria-label', 'Next month, ' + months[nextMonth] + ' ' + year);
            prevButton.setAttribute('aria-label', 'Previous month, ' + months[prevMonth] + ' ' + year);
        }
    }, {
        key: 'setTableRoles',
        value: function setTableRoles() {
            var table = this.document.querySelector('.ui-datepicker-calendar');
            table.setAttribute('role', 'grid');
            table.setAttribute('aria-readonly', 'true');

            var tableTr = table.querySelectorAll('tr');
            tableTr.forEach(function (el) {
                el.setAttribute('role', 'row');
            });

            var tableTh = table.querySelectorAll('tr th');
            tableTh.forEach(function (el) {
                el.setAttribute('role', 'columnheader');
            });

            var tableTd = table.querySelectorAll('tr td');
            tableTd.forEach(function (el) {
                el.setAttribute('role', 'gridcell');
            });
        }
    }, {
        key: 'setTableAria',
        value: function setTableAria() {
            var table = this.document.querySelector('.ui-datepicker-calendar tr');
            var tableTd = this.document.querySelectorAll('.ui-datepicker-calendar tr td');
            var tableTh = table.querySelectorAll('th');
            var year = this.document.querySelectorAll('.ui-datepicker-year')[0].innerText;
            var month = this.document.querySelectorAll('.ui-datepicker-month')[0].innerText;

            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            tableTd.forEach(function (el) {
                // Get date name
                var dateString = month + '/' + el.innerText + '/' + year;
                var d = new Date(dateString);
                var dayName = days[d.getDay()];

                el.setAttribute('aria-label', dayName + ',' + ' ' + month + ' ' + el.innerText + ',' + ' ' + year);

                if (el.classList.contains('ui-datepicker-today')) el.setAttribute('aria-current', 'today');
                if (el.classList.contains('ui-datepicker-current-day')) {
                    el.setAttribute('aria-selected', 'true');
                    el.setAttribute('aria-label', dayName + ',' + ' ' + month + ' ' + el.innerText + ',' + ' ' + year + ' Selected');
                } else el.setAttribute('aria-selected', 'false');
            });

            var ariaTh = this.document.querySelectorAll('.ui-datepicker-calendar tr th span');
            ariaTh.forEach(function (el, index) {
                tableTh[index].setAttribute('aria-label', el.title);
            });
        }
    }, {
        key: 'placeholderActive',
        value: function placeholderActive() {
            var inputs = this.document.querySelectorAll('input');
            inputs.forEach(function (el) {
                if (!el.getAttribute('placeholder')) el.classList.add('border-highlighted');
            });
        }
    }, {
        key: 'alertMessages',
        value: function alertMessages() {
            /* eslint-disable */
            (function ($) {
                $(document).ajaxComplete(function () {
                    setTimeout(function () {
                        var alert = void 0;
                        alert = document.querySelector('#drupal-live-announce');
                        if (alert) {
                            alert.removeAttribute('aria-live');
                        }
                    }, 500);
                });
            })(jQuery
            /* esling-enable */
            );
        }
    }, {
        key: 'setIdData',
        value: function setIdData() {
            var elements = this.el.querySelectorAll('.js-form-type-managed-file .js-form-managed-file');

            if (elements) elements.forEach(function (el) {
                el.setAttribute('data-prev-id', el.getAttribute('id'));
            });
        }
    }, {
        key: 'msg',
        value: function msg() {
            var msgEl = document.createElement('DIV');
            msgEl.classList.add('error-msg');
            msgEl.setAttribute('aria-live', 'assertive');
            var msg = document.createTextNode('This field is required');
            var icon = document.createElement('I');
            icon.classList.add('material-icons');
            icon.setAttribute('aria-hidden', 'true');
            var iconTxt = document.createTextNode('error');
            icon.appendChild(iconTxt);
            msgEl.appendChild(icon);
            msgEl.appendChild(msg);
            return msgEl;
        }
    }, {
        key: 'displayMsg',
        value: function displayMsg(e) {
            var msg = this.msg.cloneNode(true);
            if (e.target.closest('.js-form-item').querySelector('.error-msg') === null) {
                // Check that element exists on the page.
                if (e.target.closest('.js-form-item').querySelector('input') !== null) {
                    var describedby = e.target.closest('.js-form-item').querySelector('input').getAttribute('aria-describedby'
                    // Set new id with aria-describedby from closest element.
                    );msg.setAttribute('id', describedby);
                } else if (e.target.closest('.js-form-item').querySelector('textarea') !== null) {
                    var describedbyTxt = e.target.closest('.js-form-item').querySelector('textarea').getAttribute('aria-describedby'
                    // Set new id with aria-describedby from closest element.
                    );msg.setAttribute('id', describedbyTxt);
                }
                e.target.closest('.js-form-item').appendChild(msg);
            }
        }
    }, {
        key: 'removeMsg',
        value: function removeMsg(e) {
            var msg = e.target.closest('.js-form-item').querySelector('.error-msg');
            if (msg) e.target.closest('.js-form-item').removeChild(msg);
        }
    }, {
        key: 'validate',
        value: function validate(e) {
            e.target.classList.contains('hasDatepicker') ? this.validateDatePicker(e) : this.validateInput(e);
        }
    }, {
        key: 'validateDatePicker',
        value: function validateDatePicker(e) {
            var _this4 = this;

            setTimeout(function () {
                if (e.target.value.length > 0) {
                    e.target.classList.add('filled');
                    e.target.classList.remove('validate');
                    _this4.removeMsg(e);
                } else {
                    e.target.classList.remove('filled');
                    e.target.classList.add('validate');
                    _this4.displayMsg(e);
                }
            }, 100);
        }
    }, {
        key: 'validateInput',
        value: function validateInput(e) {
            if (e.target.value.length === 0) {
                e.target.classList.add('validate');
                this.displayMsg(e);
            } else {
                e.target.classList.remove('validate');
                e.target.classList.add('filled');
                this.removeMsg(e);
            }
        }
    }, {
        key: 'moveDatepicker',
        value: function moveDatepicker(e) {
            var datepicker = this.document.querySelector('.ui-datepicker');
            var wrap = e.target.closest('.inner');
            wrap.appendChild(datepicker);
        }
    }, {
        key: 'datepickerNavigation',
        value: function datepickerNavigation(e) {
            var datepicker = this.document.querySelector('.ui-datepicker');
            this.updateHeaderElements();
            if (datepicker.getAttribute('listener') != 'true') {
                var that = this;
                datepicker.addEventListener('keydown', function (e) {
                    if (e.keyCode === 27) {
                        datepicker.style.display = 'none';
                    } else if (e.keyCode === 39) {
                        if (!e.target.classList.contains('ui-datepicker-close') && e.target.classList.contains('ui-state-default')) {
                            e.preventDefault();
                            that.nextDay(e.target);
                        }
                    } else if (e.keyCode === 37) {
                        if (!e.target.classList.contains('ui-datepicker-close') && e.target.classList.contains('ui-state-default')) {
                            e.preventDefault();
                            that.prevDay(e.target);
                        }
                    } else if (e.keyCode === 38) {
                        // UP arrow key
                        if (!e.target.classList.contains('ui-datepicker-close') && e.target.classList.contains('ui-state-default')) {
                            e.preventDefault();
                            that.upHandler(e.target, datepicker);
                        }
                    } else if (e.keyCode === 40) {
                        // DOWN arrow key
                        if (!e.target.classList.contains('ui-datepicker-close') && e.target.classList.contains('ui-state-default')) {
                            e.preventDefault();
                            that.downHandler(e.target, datepicker);
                        }
                    } else if (e.keyCode === 9 && e.shiftKey) {
                        // SHIFT + TAB
                        e.preventDefault();
                        if (e.target.classList.contains('ui-datepicker-prev')) // the prev link
                            document.querySelector('a.ui-datepicker-next').focus();else if (e.target.classList.contains('ui-datepicker-next')) {
                            // the next link
                            var arrow = e.target;
                            var container = arrow.closest('.ui-datepicker');
                            var rowContext = container.querySelector('table tbody tr');
                            var rowTds = Array.from(rowContext.querySelectorAll('td'));
                            rowTds.forEach(function (el) {

                                if (!el.classList.contains('ui-state-disabled')) {
                                    el.querySelector('a').focus();
                                }
                            });
                        } else if (e.target.classList.contains('ui-state-default')) {
                            document.querySelector('a.ui-datepicker-prev').focus();
                        }
                    } else if (e.keyCode === 9) {
                        e.preventDefault();
                        if (e.target.classList.contains('ui-datepicker-prev')) {
                            var _arrow = e.target;
                            var _container = _arrow.closest('.ui-datepicker');
                            var _rowContext = _container.querySelector('table tbody tr');
                            var _rowTds = Array.from(_rowContext.querySelectorAll('td'));
                            _rowTds.forEach(function (el) {
                                if (!el.classList.contains('ui-state-disabled')) {
                                    el.querySelector('a').focus();
                                }
                            });
                        } else if (e.target.classList.contains('ui-datepicker-next')) {
                            // the next link
                            document.querySelector('a.ui-datepicker-prev').focus();
                        } else if (e.target.classList.contains('ui-state-default')) {
                            document.querySelector('a.ui-datepicker-next').focus();
                        }
                    } else if (e.keyCode === 13) {
                        if (e.target.classList.contains('ui-datepicker-prev')) {
                            e.preventDefault();
                            that.previousMonthWithoutFocus();
                        }
                    }
                });
                datepicker.setAttribute('listener', 'true');
            }
        }
    }, {
        key: 'upHandler',
        value: function upHandler(target, cont) {
            var prevLink = this.document.querySelector('.ui-datepicker-prev');
            var rowContext = target.closest('tr');
            if (!rowContext) {
                return;
            }
            var that = this;
            var rowTds = Array.from(rowContext.querySelectorAll('td'));
            var rowLinks = Array.from(rowContext.querySelectorAll('a.ui-state-default'));
            var targetIndex = rowLinks.indexOf(target);
            var prevRow = rowContext.previousSibling;
            if (prevRow) {
                var prevRowTds = Array.from(prevRow.querySelectorAll('td'));
                var parallel = prevRowTds[targetIndex];
                var linkCheck = parallel.querySelector('a.ui-state-default');

                if (prevRow && parallel && linkCheck) {
                    // there is a previous row, a td at the same index
                    // of the target AND theres a link in that td
                    linkCheck.focus();
                } else {
                    // we're either on the first row of a month, or we're on the
                    // second and there is not a date link directly above the target
                    prevLink.click();
                    setTimeout(function () {
                        // updating the cached header elements
                        that.updateHeaderElements();
                        var newRows = Array.from(cont.querySelectorAll('tr'));
                        var lastRow = newRows[newRows.length - 1];
                        var lastRowTds = Array.from(lastRow.querySelectorAll('td'));
                        var tdParallelIndex = rowTds.indexOf(target.parentNode);
                        var newParallel = lastRowTds[tdParallelIndex];
                        var newCheck = newParallel.querySelector('a.ui-state-default');

                        if (lastRow && newParallel && newCheck) {
                            newCheck.focus();
                        } else {
                            // theres no date link on the last week (row) of the new month
                            // meaning its an empty cell, so we'll try the 2nd to last week
                            var secondLastRow = newRows[newRows.length - 2];
                            var secondTds = secondLastRow.querySelector('td');
                            var targetTd = secondTds[tdParallelIndex];
                            var _linkCheck = targetTd.querySelector('a.ui-state-default');

                            if (_linkCheck) {
                                _linkCheck.focus();
                            }
                        }
                    }, 0);
                }
            } else {
                prevLink.click();
                setTimeout(function () {
                    // updating the cached header elements
                    that.updateHeaderElements();
                    var newRows = Array.from(cont.querySelectorAll('tr'));
                    var lastRow = newRows[newRows.length - 1];
                    var lastRowTds = Array.from(lastRow.querySelectorAll('td'));
                    var tdParallelIndex = rowTds.indexOf(target.parentNode);
                    var newParallel = lastRowTds[tdParallelIndex];
                    var newCheck = newParallel.querySelector('a.ui-state-default');

                    if (lastRow && newParallel && newCheck) {
                        newCheck.focus();
                    } else {
                        // theres no date link on the last week (row) of the new month
                        // meaning its an empty cell, so we'll try the 2nd to last week
                        var secondLastRow = newRows[newRows.length - 2];
                        var secondTds = Array.from(secondLastRow.querySelectorAll('td'));
                        var targetTd = secondTds[tdParallelIndex];
                        var _linkCheck2 = targetTd.querySelector('a.ui-state-default');

                        if (_linkCheck2) {
                            _linkCheck2.focus();
                        }
                    }
                }, 0);
            }
        }
    }, {
        key: 'downHandler',
        value: function downHandler(target, cont) {
            var that = this;
            var nextLink = this.document.querySelector('.ui-datepicker-next');
            var targetRow = target.closest('tr');
            if (!targetRow) {
                return;
            }

            var targetCells = Array.from(targetRow.querySelectorAll('td'));
            var cellIndex = targetCells.indexOf(target.parentNode);
            var nextRow = targetRow.nextElementSibling;
            if (nextRow) {
                var nextRowCells = Array.from(nextRow.querySelectorAll('td'));
                var nextWeekTd = nextRowCells[cellIndex];
                var nextWeekCheck = nextWeekTd.querySelector('a.ui-state-default');

                if (nextRow && nextWeekTd && nextWeekCheck) {
                    // theres a next row, a TD at the same index of `target`,
                    // and theres an anchor within that td
                    nextWeekCheck.focus();
                } else {
                    nextLink.click();
                    setTimeout(function () {
                        // updating the cached header elements
                        that.updateHeaderElements();

                        var nextMonthTrs = Array.from(cont.querySelectorAll('tbody tr'));
                        var nextMonthTrs2 = cont.querySelectorAll('tbody tr');
                        var firstTds = Array.from(nextMonthTrs2[0].querySelectorAll('td'));
                        var firstParallel = firstTds[cellIndex];
                        var firstCheck = firstParallel.querySelector('a.ui-state-default');

                        if (firstParallel && firstCheck) {
                            firstCheck.focus();
                        } else {
                            // lets try the second row b/c we didnt find a
                            // date link in the first row at the target's index

                            var secondRow = nextMonthTrs[1];
                            var secondTds = Array.from(secondRow.querySelectorAll('td'));
                            var secondRowTd = secondTds[cellIndex];
                            var secondCheck = secondRowTd.querySelector('a.ui-state-default');

                            if (secondRow && secondCheck) {
                                secondCheck.focus();
                            }
                        }
                    }, 0);
                }
            } else {
                nextLink.click();
                setTimeout(function () {
                    // updating the cached header elements
                    that.updateHeaderElements();
                    var nextMonthTrs = Array.from(cont.querySelectorAll('tbody tr'));
                    var nextMonthTrs2 = cont.querySelectorAll('tbody tr');
                    var firstTds = Array.from(nextMonthTrs2[0].querySelectorAll('td'));
                    var firstParallel = firstTds[cellIndex];
                    var firstCheck = firstParallel.querySelector('a.ui-state-default');

                    if (firstParallel && firstCheck) {
                        firstCheck.focus();
                    } else {
                        // lets try the second row b/c we didnt find a
                        // date link in the first row at the target's index
                        var secondRow = nextMonthTrs[1];

                        var secondTds = Array.from(secondRow.querySelectorAll('td'));
                        var secondRowTd = secondTds[cellIndex];
                        var secondCheck = secondRowTd.querySelector('a.ui-state-default');

                        if (secondRow && secondCheck) {
                            secondCheck.focus();
                        }
                    }
                }, 0);
            }
        }
    }, {
        key: 'nextDay',
        value: function nextDay(dateLink) {
            if (!dateLink) {
                return;
            }
            var td = dateLink.closest('td');
            if (!td) {
                return;
            }
            var nextTd = td.nextElementSibling;
            if (nextTd) {
                var nextDateLink = nextTd.querySelector('a.ui-state-default');
                if (nextTd && nextDateLink) {
                    nextDateLink.focus();
                } else {
                    this.handleNext(dateLink);
                }
            } else {
                this.handleNext(dateLink);
            }
        }
    }, {
        key: 'prevDay',
        value: function prevDay(dateLink) {
            if (!dateLink) {
                return;
            }
            var td = dateLink.closest('td');
            if (!td) {
                return;
            }
            var prevTd = td.previousSibling;
            if (prevTd) {
                var prevDateLink = prevTd.querySelector('a.ui-state-default');
                if (prevTd && prevDateLink) {
                    prevDateLink.focus();
                } else {
                    this.handlePrevious(dateLink);
                }
            } else {
                this.handlePrevious(dateLink);
            }
        }
    }, {
        key: 'handleNext',
        value: function handleNext(target) {
            if (!target) {
                return;
            }
            var currentRow = target.closest('tr');
            var nextRow = currentRow.nextElementSibling;
            if (!nextRow || nextRow.length === 0) {
                this.nextMonth();
            } else {
                var nextRowFirstDate = nextRow.querySelector('a.ui-state-default');
                if (nextRowFirstDate) {
                    nextRowFirstDate.focus();
                }
            }
        }
    }, {
        key: 'nextMonth',
        value: function nextMonth() {
            var nextMon = this.document.querySelector('.ui-datepicker-next');
            var container = document.getElementById('ui-datepicker-div');
            nextMon.click();
            var that = this;
            // focus the first day of the new month
            setTimeout(function () {
                var firstDate = container.querySelector('a.ui-state-default');
                that.updateHeaderElements();
                firstDate.focus();
            }, 0);
        }
    }, {
        key: 'handlePrevious',
        value: function handlePrevious(target) {
            if (!target) {
                return;
            }
            var currentRow = target.closest('tr');
            if (!currentRow) {
                return;
            }
            var previousRow = currentRow.previousSibling;
            if (!previousRow) {
                // there is not previous row, so we go to previous month...
                this.previousMonth();
            } else {
                var prevRowDates = previousRow.querySelectorAll('td a.ui-state-default');
                var prevRowDate = prevRowDates[prevRowDates.length - 1];

                if (prevRowDate) {
                    setTimeout(function () {
                        prevRowDate.focus();
                    }, 0);
                }
            }
        }
    }, {
        key: 'previousMonth',
        value: function previousMonth() {
            var prevLink = this.document.querySelector('.ui-datepicker-prev');
            var container = document.getElementById('ui-datepicker-div');
            var that = this;
            prevLink.click
            // focus last day of new month
            ();setTimeout(function () {
                var trs = container.querySelectorAll('tr');
                var lastRowTdLinks = trs[trs.length - 1].querySelectorAll('td a.ui-state-default');
                var lastDate = lastRowTdLinks[lastRowTdLinks.length - 1];
                that.updateHeaderElements();
                lastDate.focus();
            }, 0);
        }
    }, {
        key: 'previousMonthWithoutFocus',
        value: function previousMonthWithoutFocus() {
            var prevLink = this.document.querySelector('.ui-datepicker-prev');
            prevLink.click();
            document.querySelector('a.ui-datepicker-prev').focus();
        }
    }, {
        key: 'updateHeaderElements',
        value: function updateHeaderElements() {
            var context = document.getElementById('ui-datepicker-div');
            if (!context) {
                return;
            }

            var prev = context.querySelector('.ui-datepicker-prev');
            var next = context.querySelector('.ui-datepicker-next'

            //make them click/focus - able
            );next.href = 'javascript:void(0)';
            prev.href = 'javascript:void(0)';

            next.setAttribute('role', 'button');
            prev.setAttribute('role', 'button');
            this.appendOffscreenMonthText(next);
            this.appendOffscreenMonthText(prev);

            next.addEventListener('click', this.handleNextClicks.bind(this));
            prev.addEventListener('click', this.handlePrevClicks.bind(this));
        }
    }, {
        key: 'handleNextClicks',
        value: function handleNextClicks() {
            var that = this;
            setTimeout(function () {
                that.updateHeaderElements();
                document.querySelector('.ui-datepicker-next').focus();
            }, 0);
        }
    }, {
        key: 'handlePrevClicks',
        value: function handlePrevClicks() {
            var that = this;
            setTimeout(function () {
                that.updateHeaderElements();
                document.querySelector('.ui-datepicker-next').focus();
            }, 0);
        }
    }, {
        key: 'appendOffscreenMonthText',
        value: function appendOffscreenMonthText(button) {
            var buttonText = void 0;
            var isNext = button.classList.contains('ui-datepicker-next');
            var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

            var currentMonth = this.document.querySelector('.ui-datepicker-title .ui-datepicker-month').innerText.toLowerCase();
            var monthIndex = months.indexOf(currentMonth);
            var currentYear = this.document.querySelector('.ui-datepicker-title .ui-datepicker-year').innerText.toLowerCase();
            var adjacentIndex = isNext ? monthIndex + 1 : monthIndex - 1;

            if (isNext && currentMonth === 'december') {
                currentYear = parseInt(currentYear, 10) + 1;
                adjacentIndex = 0;
            } else if (!isNext && currentMonth === 'january') {
                currentYear = parseInt(currentYear, 10) - 1;
                adjacentIndex = months.length - 1;
            }

            buttonText = isNext ? 'Next Month, ' + this.firstToCap(months[adjacentIndex]) + ' ' + currentYear : 'Previous Month, ' + this.firstToCap(months[adjacentIndex]) + ' ' + currentYear;

            button.querySelector('.ui-icon').html = buttonText;
        }

        // Returns the string with the first letter capitalized

    }, {
        key: 'firstToCap',
        value: function firstToCap(s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
        }
    }, {
        key: 'setFilled',
        value: function setFilled(e) {
            var combobox = e.target.closest('.form-item').querySelector('.select-selected');
            combobox.classList.add('filled');
        }
    }, {
        key: 'setIcon',
        value: function setIcon() {
            var datepicker = Array.from(this.el.querySelectorAll('.js-form-type-date'));

            datepicker.forEach(function (el) {
                setTimeout(function () {
                    var imgContainer = el.querySelector('.img-container');
                    var img = imgContainer.querySelector('img');
                    img.setAttribute('src', '/themes/cardozo/assets/images/date_range-blue.svg');
                    img.setAttribute('aria-hidden', 'true');

                    el.addEventListener('mouseover', function () {
                        el.classList.add('hovered');
                        var img = el.querySelector('.calendar-img');
                        img.setAttribute('src', '/themes/cardozo/assets/images/date_range-white.svg');
                        img.setAttribute('aria-hidden', 'true');
                    });
                    el.addEventListener('mouseout', function () {
                        el.classList.remove('hovered');
                        var img = el.querySelector('.calendar-img');
                        img.setAttribute('src', '/themes/cardozo/assets/images/date_range-blue.svg');
                        img.setAttribute('aria-hidden', 'true');
                    });
                }, 120);
            });
        }
    }, {
        key: 'setAria',
        value: function setAria() {
            this.getDatePickerHeader().forEach(function (el) {
                var icon = el.querySelectorAll('a .ui-icon');
                icon.forEach(function (element) {
                    element.setAttribute('aria-hidden', 'true');
                });
            });
        }
    }, {
        key: 'customTxtArea',
        value: function customTxtArea() {
            var _this5 = this;

            var txtArea = this.el.querySelectorAll('.js-form-type-textarea');

            txtArea.forEach(function (el) {
                el.querySelector('textarea').classList.add('resizable-textarea');
                var grippie = document.createElement('DIV');
                grippie.classList.add('grippie');

                var icon = document.createElement('DIV');
                icon.setAttribute('class', 'icon');

                var line = document.createElement('SPAN');
                line.setAttribute('class', 'icon-line');
                icon.appendChild(line);

                grippie.appendChild(icon);
                el.querySelector('textarea').parentElement.appendChild(grippie);

                grippie.addEventListener('mousedown', _this5.startDrag.bind(_this5));
            });
        }
    }, {
        key: 'startDrag',
        value: function startDrag(e) {
            var textarea = e.target.closest('.form-item').querySelector('textarea');
            var staticOffset = textarea.offsetHeight - e.pageY;

            window.addEventListener('mousemove', performDrag);
            window.addEventListener('mouseup', endDrag);

            function performDrag(e) {
                textarea.style.height = Math.max(32, staticOffset + e.pageY) + 'px';
            }

            function endDrag(e) {
                window.removeEventListener('mousemove', performDrag);
            }
        }
    }, {
        key: 'removeAriaRequired',
        value: function removeAriaRequired() {
            var _this6 = this;

            setTimeout(function () {
                _this6.radios = _this6.getRadios();
                _this6.radios.forEach(function (el) {
                    var input = el.querySelector('input');
                    input.removeAttribute('aria-required');
                });
            }, 100);
        }
    }, {
        key: 'addRole',
        value: function addRole() {
            this.dateList = this.getDateList();
            this.dateList.forEach(function (el) {
                el.setAttribute('role', 'group');
                var label = el.querySelector('label > span').innerText;
                el.setAttribute('aria-labelledby', label);
            });
        }
    }, {
        key: 'setAriaDescribedBy',
        value: function setAriaDescribedBy() {
            this.managedFile = this.getManagedFile();
            this.managedFile.forEach(function (el) {
                var descriptionId = el.querySelector('.webform-element-description').getAttribute('id');
                el.querySelector('.webform-file-button').setAttribute('aria-describedby', descriptionId);
            });
        }
    }, {
        key: 'replaceLabel',
        value: function replaceLabel() {
            this.formTypeManaged = this.getManagedFile();
            this.formTypeManaged.forEach(function (el) {
                var labels = Array.from(el.querySelectorAll('label'));
                var label = labels[0];
                var id = label.getAttribute('id');
                var innerContent = label.innerHTML;
                var div = document.createElement('DIV');
                div.setAttribute('id', id);
                div.classList.add('newlabel');
                div.innerHTML = innerContent;
                var parent = label.parentElement;
                parent.insertBefore(div, parent.firstChild);
                var btnLabel = el.querySelector('.js-form-managed-file label');
                btnLabel.setAttribute('aria-labelledby', id);
                label.classList.add('visually-hidden');
            });
        }
    }, {
        key: 'setAccessibleCalendarImg',
        value: function setAccessibleCalendarImg() {
            var _this7 = this;

            setTimeout(function () {
                var imgs = _this7.getDatePickerImg();
                imgs.forEach(function (img) {
                    var inner = img.parentElement;
                    var span = document.createElement('span');
                    span.setAttribute('role', 'button');
                    span.setAttribute('tabindex', '0');
                    span.classList.add('ui-datepicker-trigger');
                    span.classList.add('img-container');
                    span.appendChild(img
                    // img.classList.remove('ui-datepicker-trigger')
                    );img.classList.add('calendar-img');
                    inner.appendChild(span);
                    span.addEventListener('keydown', function (e) {
                        if (e.keyCode === 32 || e.keyCode === 13) {
                            img.click();
                            var datePicker = img.closest('.inner').querySelector('.ui-datepicker');
                            document.addEventListener('keydown', function (e) {
                                if (e.keyCode === 27) datePicker.style.display = 'none';
                            });
                        }
                    });
                });
            }, 100);
        }
    }, {
        key: 'setAccessiblePhoneField',
        value: function setAccessiblePhoneField() {
            var _this8 = this;

            setTimeout(function () {
                var flagDiv = _this8.getPhoneFlags();
                var span = document.createElement('SPAN');
                span.classList.add('visually-hidden');
                var txt = document.createTextNode('Country phone prefix');
                span.appendChild(txt);
                flagDiv.forEach(function (el) {
                    el.appendChild(span);
                });
            }, 100);
        }
    }, {
        key: 'setIDPhonePrefix',
        value: function setIDPhonePrefix() {
            var _this9 = this;

            setTimeout(function () {
                var flagContainer = _this9.getFlagContainer();
                flagContainer.forEach(function (el) {
                    var selectedFlag = el.querySelector('.selected-flag');
                    var countryList = el.querySelector('.country-list');
                    selectedFlag.setAttribute('aria-expanded', false);
                    var id = countryList.getAttribute('aria-activedescendant');
                    selectedFlag.setAttribute('aria-activedescendant', id);
                    var option = el.querySelectorAll('.country');
                    option.forEach(function (el) {
                        el.addEventListener('click', function (e) {
                            var id = e.target.closest('.country').getAttribute('id');
                            selectedFlag.setAttribute('aria-activedescendant', id);
                        });
                    });
                    el.addEventListener('click', function (e) {
                        setTimeout(function () {
                            if (e.target.closest('.flag-container').querySelector('.country-list').classList.contains('hide')) selectedFlag.setAttribute('aria-expanded', false);else selectedFlag.setAttribute('aria-expanded', true);
                        }, 130);
                    });
                });
            }, 100);
        }
    }, {
        key: 'setAccessibleCustomSelect',
        value: function setAccessibleCustomSelect() {
            var customSelect = this.getCustomSelect();
            customSelect.forEach(function (el) {
                var combobox = el.querySelector('.select-selected');
                var options = el.querySelectorAll('.custom-item');
                var selected = void 0;
                options.forEach(function (el) {
                    el.addEventListener('click', function (e) {
                        if (e.target.classList.contains('text')) selected = e.target.innerText;else selected = e.target.querySelector('.text').innerText;
                        combobox.setAttribute('aria-activedescendant', selected);
                    });
                });
            });
        }
    }, {
        key: 'setAccessibleErrorForm',
        value: function setAccessibleErrorForm() {
            /* eslint-disable */
            (function ($) {
                $(document).ajaxComplete(function () {
                    var errMsg = void 0;
                    var el = document.querySelector("[role='contentinfo']");
                    if (el.getAttribute('aria-label') === 'Error message') errMsg = el;
                    if (errMsg) {
                        errMsg.removeAttribute('role');
                        errMsg.removeAttribute('aria-label');
                    }
                });
            })(jQuery
            /* esling-enable */
            );
        }
    }, {
        key: 'setBtnFocus',
        value: function setBtnFocus() {
            var uploadInput = this.getUploadBtns();
            uploadInput.forEach(function (el) {
                var btn = el.closest('.js-form-managed-file').querySelector('.webform-file-button');
                el.addEventListener('focusin', function (e) {
                    btn.focus();
                    btn.classList.add('upload-focus-visible');
                });
                el.addEventListener('focusout', function (e) {
                    btn.classList.remove('upload-focus-visible');
                });
            });
        }
    }, {
        key: 'getTooltip',
        value: function getTooltip() {
            var help = this.el.querySelectorAll('.webform-element-help');
            help.forEach(function (el) {
                var attr = el.getAttribute('data-webform-help');
                var div = '<div role="tooltip">' + attr + '</div>';
                el.setAttribute('data-webform-help', div);
            });
        }
    }, {
        key: 'setColor',
        value: function setColor(e) {
            return e.target.value.length > 0 ? e.target.classList.add('filled') : e.target.classList.remove('filled');
        }
    }, {
        key: 'getRequired',
        value: function getRequired() {
            return Array.from(this.el.querySelectorAll('[required=required]'));
        }
    }, {
        key: 'getFields',
        value: function getFields() {
            return Array.from(this.el.querySelectorAll('input, textarea'));
        }
    }, {
        key: 'getCustomFields',
        value: function getCustomFields() {
            return Array.from(this.el.querySelectorAll('.custom-item'));
        }
    }, {
        key: 'getFileUploadBtn',
        value: function getFileUploadBtn() {
            return Array.from(this.el.querySelectorAll('.webform-file-button'));
        }
    }, {
        key: 'getDatepicker',
        value: function getDatepicker() {
            return Array.from(this.el.querySelectorAll('.hasDatepicker'));
        }
    }, {
        key: 'getDatepickerTrigger',
        value: function getDatepickerTrigger() {
            return Array.from(this.el.querySelectorAll('.ui-datepicker-trigger, .hasDatepicker'));
        }
    }, {
        key: 'getErrorMsg',
        value: function getErrorMsg() {
            var err = Array.from(this.el.querySelectorAll('.form-item--error-message'));
            err.forEach(function (el) {
                var icon = document.createElement('I');
                icon.classList.add('material-icons');
                var iconTxt = document.createTextNode('error');
                icon.appendChild(iconTxt);
                el.appendChild(icon);
                return el;
            });
        }
    }, {
        key: 'removeClass',
        value: function removeClass() {
            // Remove visually hidden class from fieldset span on webform.
            var fieldset = Array.from(this.el.querySelectorAll('.fieldset-legend'));
            fieldset.forEach(function (el) {
                el.classList.remove('visually-hidden');
            });
        }
    }, {
        key: 'getDatePickerHeader',
        value: function getDatePickerHeader() {
            return Array.from(this.el.querySelectorAll('.ui-datepicker-header'));
        }
    }, {
        key: 'getRadios',
        value: function getRadios() {
            return Array.from(this.el.querySelectorAll('.js-form-type-radio'));
        }
    }, {
        key: 'getDateList',
        value: function getDateList() {
            return Array.from(this.el.querySelectorAll('.js-form-type-datelist'));
        }
    }, {
        key: 'getManagedFile',
        value: function getManagedFile() {
            return Array.from(this.el.querySelectorAll('.js-form-type-managed-file'));
        }
    }, {
        key: 'getFormTypeManaged',
        value: function getFormTypeManaged() {
            return Array.from(this.el.querySelectorAll('.js-form-type-managed-file label'));
        }
    }, {
        key: 'getDatePickerImg',
        value: function getDatePickerImg() {
            return Array.from(this.el.querySelectorAll('.js-form-type-date .ui-datepicker-trigger'));
        }
    }, {
        key: 'getPhoneFlags',
        value: function getPhoneFlags() {
            return Array.from(this.el.querySelectorAll('.selected-flag'));
        }
    }, {
        key: 'getFlagContainer',
        value: function getFlagContainer() {
            return Array.from(this.el.querySelectorAll('.flag-container'));
        }
    }, {
        key: 'getCustomSelect',
        value: function getCustomSelect() {
            return Array.from(this.el.querySelectorAll('.custom-select'));
        }
    }, {
        key: 'getUploadBtns',
        value: function getUploadBtns() {
            return Array.from(this.el.querySelectorAll('.webform-file-button-input'));
        }
    }, {
        key: 'getSubmitItem',
        value: function getSubmitItem() {
            return Array.from(this.el.querySelectorAll('.submit-item .js-hide'));
        }
    }]);

    return Webform;
}();

//* ----------------------------------------------------------------------------
//
//  This code is takes care of upload file input in webforms
//
//* ----------------------------------------------------------------------------

var WebformUpload = function () {
    function WebformUpload(el) {
        _classCallCheck(this, WebformUpload);

        this.el = el;
        this.fileUploadBtn = this.getFileUploadBtn();
        this.fileInputs = this.getFileElements();

        this.setUp();
    }

    _createClass(WebformUpload, [{
        key: 'setUp',
        value: function setUp() {
            var _this = this;

            if (this.getFileElements()) this.getFileElements().forEach(function (el) {
                var uploadButton = el.querySelector('.webform-file-button-input');
                var uploadLabel = el.querySelector('.webform-file-button');
                var removeButton = el.querySelector('.js-form-submit:not(.js-hide)');
                var isMulti = _this.getIsMulti(el, uploadButton);
                var isChangedWithAjax = el.getAttribute('id').split('--')[1];

                if (isMulti) isChangedWithAjax ? _this.handleMultiple(el, uploadLabel, removeButton) : _this.setAndUpdate(el, uploadLabel);else isChangedWithAjax ? _this.handleSingle(el, uploadLabel, removeButton) : _this.setAndUpdate(el, uploadLabel);
            });
        }
    }, {
        key: 'setAndUpdate',
        value: function setAndUpdate(el, uploadLabel) {
            this.addIcon(el, uploadLabel);
        }
    }, {
        key: 'handleMultiple',
        value: function handleMultiple(el, uploadLabel, removeButton) {
            uploadLabel.classList.add('multiple');
            if (removeButton) removeButton.classList.add('multiple');

            var hasFiles = this.hasFiles(el);

            var parent = el.closest('.js-form-type-managed-file');
            var parentSibiling = parent.previousElementSibling;

            if (!hasFiles) {
                uploadLabel.classList.remove('multiple');
                if (removeButton) removeButton.classList.remove('multiple');
                this.addIcon(el, uploadLabel);
            } else this.handleSuccess(parent);

            if (parentSibiling !== null && parentSibiling.hasAttribute('data-drupal-messages')) this.handleError(parent, parentSibiling);
        }
    }, {
        key: 'handleSingle',
        value: function handleSingle(el, uploadLabel, removeButton) {
            var hasFiles = this.hasFiles(el);
            var parent = el.closest('.js-form-type-managed-file');
            var parentSibiling = parent.previousElementSibling;

            if (hasFiles) {
                this.handleSuccess(parent);
                this.addImageIcon(el);
            } else if (uploadLabel) this.addIcon(el, uploadLabel);

            if (parentSibiling !== null && parentSibiling.hasAttribute('data-drupal-messages')) this.handleError(parent, parentSibiling);
        }
    }, {
        key: 'hasFiles',
        value: function hasFiles(el) {
            return this.getFilePreviews(el).length > 0;
        }
    }, {
        key: 'addImageIcon',
        value: function addImageIcon(el) {
            this.getFilePreviews(el).forEach(function (el) {
                if (!el.querySelector('.material-icons')) {
                    var icon = document.createElement('I');
                    icon.classList.add('material-icons');
                    icon.setAttribute('aria-hidden', 'true');
                    var iconTxt = document.createTextNode('insert_photo');
                    icon.appendChild(iconTxt);

                    el.appendChild(icon);
                }
            });
        }
    }, {
        key: 'addIcon',
        value: function addIcon(el, uploadLabel) {
            var icon = document.createElement('I');
            icon.classList.add('material-icons');
            icon.classList.add('upload-icon');
            icon.setAttribute('aria-hidden', 'true');
            var iconTxt = document.createTextNode('cloud_upload');
            icon.appendChild(iconTxt);

            el.appendChild(icon);

            icon.addEventListener('click', function () {
                uploadLabel.click();
            });
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess(el) {
            if (!el.querySelector('.success-message')) {
                var div = document.createElement('DIV');
                div.setAttribute('aria-live', 'assertive');
                var successMsg = document.createElement('P');
                successMsg.classList.add('success-message');
                var msgTxt = document.createTextNode('File has been successfully uploaded');
                successMsg.appendChild(msgTxt);
                el.querySelector('.description').appendChild(div);
                this.addSuccessIcon(successMsg);
                div.appendChild(successMsg);
            }
        }
    }, {
        key: 'handleError',
        value: function handleError(el, errorDiv) {
            if (!el.classList.contains('error')) {
                var div = document.createElement('DIV');
                div.setAttribute('aria-live', 'assertive');
                el.classList.add('error');
                el.querySelector('.description').appendChild(div);
                errorDiv.classList.add('error-message');
                this.addErrorIcon(errorDiv);
                div.appendChild(errorDiv);
            }
        }
    }, {
        key: 'addSuccessIcon',
        value: function addSuccessIcon(el) {
            var icon = document.createElement('I');
            icon.classList.add('material-icons');
            icon.setAttribute('aria-hidden', 'true');
            var iconTxt = document.createTextNode('check_circle');
            icon.appendChild(iconTxt);
            el.appendChild(icon);
        }
    }, {
        key: 'addErrorIcon',
        value: function addErrorIcon(el) {
            var icon = document.createElement('I');
            icon.classList.add('material-icons');
            icon.setAttribute('aria-hidden', 'true');
            var iconTxt = document.createTextNode('error');
            icon.appendChild(iconTxt);
            el.appendChild(icon);
        }
    }, {
        key: 'getIsMulti',
        value: function getIsMulti(el, uploadButton) {
            var isMulti = false;

            if (uploadButton) isMulti = uploadButton.getAttribute('multiple') !== null;

            return isMulti;
        }
    }, {
        key: 'getFileUploadBtn',
        value: function getFileUploadBtn() {
            return Array.from(this.el.querySelectorAll('.webform-file-button'));
        }
    }, {
        key: 'getFileElements',
        value: function getFileElements() {
            return Array.from(this.el.querySelectorAll('.js-form-type-managed-file .js-form-managed-file'));
        }
    }, {
        key: 'getFilePreviews',
        value: function getFilePreviews(el) {
            return Array.from(el.querySelectorAll('.file, .webform-managed-file-preview'));
        }
    }]);

    return WebformUpload;
}();

//* ---------------------------------------

//* ---------------------------------------
//  Init

window.objectFitPolyfill

//* ----------------------------------------------------------------------------
//  Multiple-Instance Modules

();var render = function render() {
    var renderModule = function renderModule(selector, Module) {
        return Array.from(document.querySelectorAll(selector)).filter(function (el) {
            return !el.getAttribute('data-rendered');
        }).forEach(function (el) {
            el.setAttribute('data-rendered', true);
            return new Module(el);
        });
    };
    renderModule('.node--type-event.node--view-mode-full', AddToCalendar);
    renderModule('.block-header-library-block', LibraryForm);
    renderModule('.who-we-are-items', WhoWeAre);
    renderModule('.paragraph--type--faqs', Faqs);
    renderModule('.node--type-event.node--view-mode-teaser', AddToCalendars);
    renderModule('.is-slider .field-profile-cards-group', FeaturedContent);
    renderModule('.is-slider .field-event-item-group', FeaturedContent);
    renderModule('.is-slider .field-news-item-group', FeaturedContent);
    renderModule('.is-gallery .field-images-group', Gallery);
    renderModule('.social-share', SocialButtons);
    renderModule('.news-view .views-exposed-form .custom-select', CustomSelectRadio);
    renderModule('.events-view .views-exposed-form .custom-select', CustomSelectRadio);
    renderModule('.tag-view .views-exposed-form .custom-select', CustomSelectRadio);
    renderModule('.views-exposed-form .custom-select', CustomSelect);
    renderModule('.search-view .views-exposed-form .custom-select', CustomSelect);
    renderModule('.webform-submission-form .custom-select', CustomSelect);
    renderModule('.our-faculty-search-view .views-exposed-form .custom-select', CustomSelect);
    renderModule('.staff-search-view .views-exposed-form .custom-select', CustomSelect);
    renderModule('.pagerer-container .pagerer-pager-standard', Linkicons$1);
    renderModule('.js-form-type-textfield.form-item-search-api-fulltext', SearchInput);
    renderModule('.js-form-type-search', SearchInput);
    renderModule('.webform-ajax-form-wrapper', Webform);
    renderModule('.paragraph--type--webform form', WebformUpload);
};

// TODO: Better observe targeting for performance
if (document.body.className.match(/\stoolbar-/) && typeof window.MutationObserver === 'function') new window.MutationObserver(function (mutations) {
    return render();
}).observe(document.body, { subtree: true, childList: true });

render

//* ----------------------------------------------------------------------------
//  Single-Instance Modules

();var modules = [BodyStates, Linkicons, Dropdown, StickyHeader, StickyBreadcrumbs, VideoLightbox, MobileMenu, Search, FocusCorrect, CookieBanner, CustomVideoControls, LinkAria, ModalsFocus];

modules.forEach(function (Module) {
    return new Module();
}

//* ---------------------------------------
//  Fire objectFit polyfill on resize

);window.addEventListener('resize', function () {
    return window.objectFitPolyfill();
}

//* ---------------------------------------
//  jQuery Dependent

);if (typeof window.jQuery === 'function') {
    window.jQuery(document).ajaxComplete(function () {
        render();

        Array.from(document.querySelectorAll('.paragraph--type--webform form')).forEach(function (el) {
            return new WebformUpload(el);
        });
    });

    window.jQuery(document).ajaxComplete(function () {
        return window.location.pathname === '/search' ? window.jQuery('.ajax-progress').remove() : null;
    });
}

// see task 41256664
Drupal.behaviors.addRelNoreferrer = {
    attach: function attach(context, settings) {
        // Select all links in the context with target="_blank".
        var links = context.querySelectorAll('a[target="_blank"]');

        // Iterate over each link and add rel="noreferrer" if not already present.
        links.forEach(function (link) {
            if (!link.hasAttribute('rel')) {
                link.setAttribute('rel', 'noreferrer');
            } else if (!link.getAttribute('rel').includes('noreferrer')) {
                link.setAttribute('rel', link.getAttribute('rel') + ' noreferrer');
            }
        });
    }
};
